// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../public/assets/fonts/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../../public/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../../public/cross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Plus Jakarta Sans";
  src: local("Plus Jakarta Sans"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
:root {
  --primary-color: #4403bf;
  --secondary-color: #fff;
  --darker-color: #290273;
  --lighter-color: #9275ed;
  --subtle-color: #d3c8ff;
  --success-color: #06c270;
  --info-color: #0063f7;
  --warning-color: #ffcc00;
  --error-color: #ff3b3b;
  --dark-1: #3a3a3c;
  --dark-2: #6b7588;
  --dark-3: #8f90a6;
  --dark-4: #c7c9d9;
  --light-1: #dde5e9;
  --light-2: #ebebf0;
  --light-3: #f2f2f5;
  --light-4: #fafafc;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 !important;
}

body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
  padding: 0% !important;
}

/* Button Styles */
.btn {
  color: var(--secondary-color);
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.top-screen-navbar {
  background-color: white !important;
}

.sticky-sidebar-styles {
  position: fixed;
  top: 0;
  left: 0;
  width: 16.6666667%;
  overflow-y: auto;
  z-index: 100;
  align-items: flex-start;
  height: 100%;
  background-color: var(--dark-1);
}

.navlink-styles {
  padding-left: 18px !important;
}

.selected-sidebar-link {
  background-color: #4403bf !important;
}

.offcanvas {
  width: 70% !important;
  background-color: var(--dark-1) !important;
  color: white !important;
  z-index: 2;
  padding-left: 0px;
}

.discussion-color {
  color: white !important;
}

.sel-discussion-color {
  color: #4403bf !important;
}

.sel-discussion-color:hover {
  color: #4403bf !important;
}

.offcanvas-body {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

/* Define the scrollbar style */
.sticky-sidebar-styles::-webkit-scrollbar {
  display: none;
}

/* Header Styles */
.navbar {
  background-color: var(--dark-1);
  color: var(--secondary-color);
}

.custom-margin-right {
  margin-right: 10px;
  /* Adjust the value as needed */
}

/* Card Styles */
.card {
  background-color: var(--secondary-color);
  color: var(--primary-color);
}

/* Sidebar Styles */
.sidebar {
  color: var(--secondary-color);
  background-color: var(--dark-1);
  height: auto;
}

/* Add these styles in your CSS or use a separate stylesheet */
.sidebar-container {
  background-color: #343a40;
  /* Dark background color */
  height: 100vh;
  overflow-x: hidden;
  width: 250px;
  /* Adjust the width as needed */
  position: fixed;
  transition: width 0.3s;
  /* Add transition for smoother animation */
}

.sidebar-container .navbar {
  width: 100%;
}

.sidebar-container .navbar-toggler {
  border: none;
  padding: 0;
}

.sidebar-container .navbar-toggler-icon {
  background-color: #fff;
  /* Color of the hamburger icon */
}

.sidebar-container .navbar-collapse {
  padding: 20px;
}

.sidebar-container .navbar-nav {
  width: 100%;
}

.sidebar-container .nav-link {
  color: #fff;
  /* Text color */
}

.nav-link:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div div:hover {
  color: #fff !important;
  /* Hover text color */
}

.nav-link div div svg:hover {
  color: #fff !important;
  /* Hover text color */
}

.sidebar-container .navbar-nav .active > .nav-link,
.sidebar-container .navbar-nav .nav-link.active,
.sidebar-container .navbar-nav .nav-link.show,
.sidebar-container .navbar-nav .show > .nav-link {
  background-color: #495057;
  /* Background color for active/hovered link */
}

.navbar .nav-link.heading::before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  /* Adjust the height of the line as needed */
  background-color: #6e6e6f;
  /* Use the appropriate color */
  opacity: 10;
  position: absolute;
  top: 0;
  left: 0;
}

.sidebar-item {
  transition: color 0.3s;
  /* Add a smooth transition effect */
  cursor: pointer;
  /* Change cursor to a hand */
}

.sidebar-item:hover {
  /* Bright white color on hover */
  color: #fff;
  /* Change text color on hover if needed */
  opacity: 1;
}

/* Add these styles in your styles/theme.scss or a separate CSS file */
.mobile-view {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--light-4);
  /* Adjust this color as needed */
  padding: 10px;
  /* Adjust this padding as needed */
}

.mobile-view .nav-link {
  flex-grow: 1;
}

/* Add these styles in your CSS or use a separate stylesheet */
.sidebar-item .dropdown-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: #fff transparent transparent transparent;
  transition: transform 0.3s;
  /* Add transition for smoother animation */
}

.logout-dropdown .dropdown-menu.show {
  position: absolute !important;
  left: -147px;
}

.questionBank .dropdown-menu {
  position: relative !important;
  transform: none !important;
  border: none;
}

.sidebar-item .dropdown-menu {
  position: absolute;
  top: 100%;
  /* Adjust positioning to prevent overlap */
  left: 0;
  width: 100%;
  padding: 10px;
  background-color: #343a40;
  /* Dark background color */
  transition: max-height 0.3s ease-in-out;
  /* Add transition for smoother animation */
  max-height: 0;
  overflow: hidden;
  z-index: 1;
  /* Ensure the dropdown is above other elements */
}

.dropdown-toggle::after {
  display: none !important;
  /* Hide default arrow */
}

.sidebar-item:hover .custom-arrow {
  transform: rotate(180deg);
}

.coursework-sidebar {
  width: 100%;
  background-color: white;
  height: 100%;
  color: black;
  border: 1px solid lightgrey;
}

.coursework-content {
  padding: 10px 0px 0px 20px;
}

.coursework-heading {
  padding: 25px 0px 0px 20px;
}

.coursework-sidebar ul {
  padding: 0;
  list-style: none;
}

.coursework-sidebar li {
  padding: 2px;
  margin-bottom: 10px;
}

.coursework-sidebar li a {
  text-decoration: none;
  color: black;
}

.profile_main_div {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.react-tel-input .form-control {
  width: 100% !important;
  height: 42px !important;
  font-size: 16px !important;
}

.right-side .form-control {
  height: 42px !important;
  font-size: 16px !important;
}

.right-side .input-group {
  height: 42px !important;
  border: 1px solid #e9eaf0;
}

.input-style {
  padding: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
  line-height: 1.5 !important;
}

.form-check-input:checked {
  background-color: #0d6efd !important;
}

.input-placeholder {
  color: #c7c9d9;
}

.modal-body .multiValue {
  border-radius: 50px !important;
}

.button-style {
  box-sizing: border-box;
  border-radius: 5px;
  background: #4403bf;
  justify-content: flex-start;
  align-items: center;
  display: center;
  color: white;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04px;
  word-wrap: break-word;
  border: none;
  cursor: pointer;
  text-align: center;
}

/* styles/Login.css */
.login-container {
  display: flex;
  min-height: 100vh;
}

.login-heading {
  margin-bottom: 20px;
  margin-top: 20px;
}

.left-side {
  min-height: 100vh;
  flex: 3 1;
  background: #ffeee8;
  position: sticky;
  top: 0;
}

.mobile-create-btns {
  width: 70%;
}

mobile-create-btns {
  width: 70%;
}

.mobile-forgot {
  display: none;
}

.forgot-icon {
  display: none;
}

.otp-icon-div {
  margin-bottom: 20px;
}

.right-side {
  flex: 3 1;
  padding: 40px 144px 40px 100px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}

label {
  font-size: 13px;
  display: block;
  color: #8f90a6;
}

/* Add your styles for Input, Button, and other elements here */
.forgot-password-link {
  margin-top: 10px;
  text-decoration: none;
  cursor: pointer;
  color: #4403bf;
}

.otp-phone {
  color: #0063f7;
}

.google-button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  justify-content: flex-start;
  align-items: center;
  display: center;
  color: #3a3a3c;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04px;
  word-wrap: break-word;
  border: 1px solid white;
  box-shadow: 2px 2px 4px rgba(94, 92, 92, 0.64);
  cursor: pointer;
  text-align: center;
}

.google-icon {
  margin-right: 10px;
}

.signup-link {
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  color: #4403bf;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  margin-top: 3px;
}

.breadcrumb-item a {
  text-decoration: none !important;
  color: #4403bf;
}

.categoriesAccordion .accordion-item:first-of-type .accordion-button {
  background-color: white;
}

.profile_main_div .dropdown-menu .show {
  left: -146px !important;
  top: 40px;
}

.filter-students .dropdown-menu .show {
  left: 0px !important;
}

.delete-edit-icon {
  height: 40px;
  padding: 9.99px;
  justify-content: flex-start;
  align-items: center;
  gap: 10.99px;
  display: inline-flex;
  background-color: white;
}

.delete-edit-stu-icon {
  height: 40px;
  padding: 9.99px;
  justify-content: flex-start;
  align-items: center;
  gap: 10.99px;
  display: inline-flex;
}

.delete-edit-stu-icon img {
  width: 20px !important;
}

.delete-edit-icon img {
  width: 20px !important;
}

.save-btn {
  width: auto;
}

.deleteBtnModal {
  border-radius: 28px;
  border: 8px solid rgba(217, 247, 42, 0.2);
  background: rgba(217, 247, 42, 0.3);
  color: #290273;
}

.mblCards {
  display: flex;
  justify-content: space-between;
}

.card-header {
  background-color: #ffffff !important;
}

.mblCards-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

table {
  border: 1.391px solid var(--Grey_2, #e4e4e4);
  border-radius: 5px;
}

tr {
  height: 55px !important;
  text-align: start !important;
}

td {
  position: relative;
  height: 55px !important;
  padding: 12px 24px !important;
  text-align: start !important;
  width: inherit !important;
}

td > div:first-child {
  height: 100% !important;
  display: flex;
  align-items: center;
  width: 100% !important;
}

th {
  position: relative;
  padding: 12px 24px !important;
}

.table-checkbox {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

.table-checkbox:checked {
  background-color: #290273 !important;
}

.mbl-card-checkbox {
  width: 18px !important;
  height: 18px !important;
}

.card-heading {
  font-size: 14px;
  color: var(--Grey_4, #1b2128);
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.Accordion-card {
  height: 60px !important;
  border-radius: 6px 6px 0px 0px !important;
}

.Accordion-card .card-header {
  height: 100% !important;
}

.sm-table {
  display: none;
}

.tox-promotion-link {
  display: none !important;
}

.options-addQuestion p {
  margin: 0 !important;
}

.formattedText p {
  margin: 0 !important;
}

.tox-statusbar {
  display: none !important;
}

.equation_image {
  position: relative;
  max-width: 75% !important;
}

.equation_tooltip {
  display: none;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #000;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
}

.equation_image:hover + .equation_tooltip {
  display: block;
}

.mq-math-mode .mq-sqrt-prefix {
  left: 0.3em !important;
  top: 0.2em !important;
}

.mq-math-mode sup.mq-nthroot {
  padding-top: 0.3em !important;
}

.accordion-button {
  height: 100%;
  background-color: transparent !important;
}

.custom-select__multi-value__remove {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  /* Set appropriate width and height for your custom image */
  width: 20px;
  height: 20px;
  /* Ensure the image is displayed properly */
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  border: none !important;
  /* Ensure cursor changes on hover */
}

#custom-switch {
  width: 45px;
  height: 25px;
}

.accordion-button {
  padding: 8px 16px !important;
}

.formattedText {
  gap: 5px;
  line-height: 30px;
}

.formattedText > span:first-child {
  width: -moz-fit-content;
  width: fit-content;
}

.inlineMath {
  display: inline;
}

/* Add media queries for responsiveness */
@media (max-width: 780px) {
  .login-container .left-side {
    display: none;
  }
  .login-container .right-side {
    padding: 0px 20px 0px 20px;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
  }
  .forgot-icon {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
  }
  .mobile-forgot {
    display: block !important;
    text-align: center !important;
    padding-bottom: 30px;
  }
  .otp-main-div {
    width: 100% !important;
  }
  .otp-icon-div {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
    margin-top: 40px;
  }
  .otp-heading {
    font-size: 20px;
  }
  .otp-phone {
    font-size: 20px;
  }
  .mobile-create-btns {
    width: 90% !important;
    position: fixed;
    bottom: 90px;
    z-index: 1000;
  }
  .mobile-create-btns-2nd {
    width: 90% !important;
    position: fixed;
    bottom: 145px;
    z-index: 1000;
  }
  .login-container {
    flex-direction: column;
  }
  .right-side {
    flex: 1 1;
  }
  .delete-edit-icon {
    height: 100%;
    padding: 8.99px;
    border: none !important;
    justify-content: flex-start;
    align-items: center;
    gap: 10.99;
    display: inline-flex;
  }
  .delete-edit-icon img {
    width: 20px !important;
  }
  .save-btn {
    width: 100% !important;
  }
  .fix-width-button {
    width: 100px !important;
  }
  .fix-width-action-button {
    width: 140px !important;
  }
  .content-div {
    height: 55vh;
    overflow-y: auto;
  }
}
@media (max-width: 780px) and (max-width: 768px) {
  .content-div {
    padding: 7px;
  }
}
@media (max-width: 780px) {
  .sidebar {
    background-color: #ffffff;
  }
  .lg-table {
    display: none !important;
  }
  .sm-table {
    display: inline-table;
  }
  td > div:first-child {
    height: 100% !important;
    display: flex;
    align-items: center;
    width: 100% !important;
    justify-content: flex-start !important;
  }
}
@media (max-width: 500px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 270px;
    /* Adjust this value to your liking */
  }
}
@media (max-width: 400px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
    /* Adjust this value to your liking */
  }
}
@media (max-width: 350px) {
  .category-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    /* Adjust this value to your liking */
  }
}
.subscription-info {
  display: flex;
  align-items: center;
}

.subscription-box {
  background-color: blue !important; /* Adjust this color to match your design */
  color: white;
  padding: 11px 14px;
  border-radius: 5px;
  margin-right: 15px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}

.logout-dropdown .dropdown-toggle {
  background: none !important;
  border: none !important;
  padding: 0;
}

.ql-editor {
  white-space: normal !important;
}

.distractor-section {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.distractor-header {
  font-size: 1rem;
  margin-bottom: 0.25rem;
}

.distractor-header .required {
  color: red;
  margin-left: 0.25rem;
}

.distractor-description {
  font-size: 0.875rem;
  color: #555;
  margin-bottom: 0.75rem;
}

.distractor-input-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1rem;
}

.custom-input {
  width: 200px;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.add-distractor-btn {
  background-color: transparent;
  border: 1px solid #4403bf;
  color: #4403bf;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.add-distractor-btn:hover {
  background-color: #4403bf;
  color: #fff;
}

.distractor-list {
  list-style: disc inside;
  padding-left: 1rem;
  margin: 0;
}

.distractor-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
}

.remove-distractor-btn {
  background: transparent;
  border: none;
  color: #4403bf;
  font-size: 0.85rem;
  cursor: pointer;
  transition: -webkit-text-decoration 0.2s;
  transition: text-decoration 0.2s;
  transition: text-decoration 0.2s, -webkit-text-decoration 0.2s;
}

.remove-distractor-btn:hover {
  text-decoration: underline;
}

td .tooltip {
  max-width: 300px !important;
  z-index: 1070;
}

td .tooltip-inner {
  max-width: 300px !important;
  text-align: left;
  padding: 8px 12px;
}

.live-class-header {
  margin-bottom: 1.5rem;
}
.live-class-header .header-top {
  padding: 1.5rem 1.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
@media (max-width: 768px) {
  .live-class-header .header-top {
    padding: 1rem 0.75rem;
    gap: 0.75rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top {
    padding: 0.75rem 0.5rem;
    gap: 0.5rem;
  }
}
.live-class-header .header-top .header-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--dark-1);
  margin: 0;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .live-class-header .header-top .header-title {
    font-size: 1.25rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top .header-title {
    font-size: 1.1rem;
  }
}
.live-class-header .header-top .action-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}
@media (max-width: 768px) {
  .live-class-header .header-top .action-container {
    gap: 0.5rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top .action-container {
    gap: 0.35rem;
  }
}
.live-class-header .header-top .action-container .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}
@media (max-width: 768px) {
  .live-class-header .header-top .action-container .action-buttons {
    gap: 0.5rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top .action-container .action-buttons {
    gap: 0.35rem;
  }
}
.live-class-header .header-top .action-container .action-buttons button {
  white-space: nowrap;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .live-class-header .header-top .action-container .action-buttons button {
    font-size: 0.85rem;
    padding: 0.4rem 0.75rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top .action-container .action-buttons button {
    font-size: 0.8rem;
    padding: 0.35rem 0.6rem;
  }
}
.live-class-header .header-top .action-container .action-buttons button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .live-class-header .header-top .action-container .action-buttons .multiple-filter-dropdown .dropdown-toggle {
    font-size: 0.85rem;
    padding: 0.4rem 0.75rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .header-top .action-container .action-buttons .multiple-filter-dropdown .dropdown-toggle {
    font-size: 0.8rem;
    padding: 0.35rem 0.6rem;
  }
}
.live-class-header .filter-container {
  padding: 0 1.5rem;
}
@media (max-width: 768px) {
  .live-class-header .filter-container {
    padding: 0 0.75rem;
  }
}
@media (max-width: 425px) {
  .live-class-header .filter-container {
    padding: 0 0.5rem;
  }
}

.live-class-tabs-container {
  padding: 0.5rem 1.5rem;
  position: relative;
}
.live-class-tabs-container .live-class-tabs {
  border-bottom: 1px solid var(--light-2);
}
.live-class-tabs-container .live-class-tabs .nav-item {
  margin-bottom: -1px;
  margin-right: 4px;
}
.live-class-tabs-container .live-class-tabs .nav-link {
  border: 1px solid transparent;
  border-bottom: none;
  color: var(--dark-2);
  font-size: 0.95rem;
  font-weight: 500;
  background-color: var(--light-3);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: all 0.2s ease;
}
.live-class-tabs-container .live-class-tabs .nav-link:hover:not(.active) {
  background-color: var(--light-2);
  color: var(--dark-1);
}
.live-class-tabs-container .live-class-tabs .nav-link.active {
  color: var(--primary-color);
  background-color: #fff;
  border-color: var(--light-2);
  border-bottom-color: #fff;
}
.live-class-tabs-container .live-class-tabs .nav-link.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.live-class-tabs-container .live-class-tabs .nav-link .badge {
  font-size: 0.7rem;
  font-weight: 400;
  padding: 0.25rem 0.5rem;
  border-radius: 50px;
}
.live-class-tabs-container .tab-content {
  margin-top: 1.5rem;
  padding: 0 0.5rem;
  overflow: visible !important;
}
.live-class-tabs-container .class-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
  overflow: visible !important;
}
.live-class-tabs-container .class-card-container .no-classes-message {
  grid-column: 1/-1;
  text-align: center;
  padding: 2rem;
  color: var(--dark-3);
}
.live-class-tabs-container .load-more-container {
  grid-column: 1/-1;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
  width: 100%;
}
.live-class-tabs-container .load-more-button {
  padding: 0.5rem 2rem;
  font-size: 0.9rem;
  min-width: 150px;
}

.class-card {
  border-radius: 8px;
  border: 1px solid var(--light-2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  overflow: visible !important;
  position: relative;
}
.class-card.live-card {
  border-left: 3px solid var(--error-color);
}
.class-card.upcoming-card {
  border-left: 3px solid var(--info-color);
}
.class-card.completed-card {
  border-left: 3px solid var(--dark-4);
}
.class-card.suspended {
  opacity: 0.7;
  background-color: var(--light-3);
}
.class-card .card-body {
  padding: 1rem;
  overflow: visible !important;
}
.class-card .class-title-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}
.class-card .class-title-container .class-title {
  font-size: 1rem;
  font-weight: 600;
  margin-right: 0.75rem;
  color: var(--dark-1);
}
.class-card .class-title-container .status-badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}
.class-card .class-details {
  margin-bottom: 0.75rem;
}
.class-card .class-details .detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  color: var(--dark-2);
  font-size: 0.85rem;
}
.class-card .class-details .detail-item .detail-icon {
  margin-right: 0.5rem;
  font-size: 0.85rem;
  color: var(--dark-3);
}
.class-card .class-details .subject-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.5rem;
}
.class-card .class-details .subject-tags .subject-badge {
  font-size: 0.7rem;
  background-color: var(--light-3);
  color: var(--dark-2);
  padding: 0.25rem 0.5rem;
}
.class-card .suspended-badge,
.class-card .rescheduled-badge {
  margin-top: 0.5rem;
}
.class-card .suspended-badge .badge,
.class-card .rescheduled-badge .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
.class-card .class-card-right {
  position: relative;
}
.class-card .class-card-options {
  position: relative;
}
.class-card .class-card-options .options-toggle-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: #6c757d;
  transition: all 0.2s;
}
.class-card .class-card-options .options-toggle-btn:hover {
  background-color: #f8f9fa;
  color: #343a40;
  z-index: 99999;
}
.class-card .class-card-options .options-menu {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  min-width: 160px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 0.5rem 0;
  z-index: 99999;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.class-card .class-card-options .options-menu .options-item {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
  color: #343a40;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.class-card .class-card-options .options-menu .options-item:hover {
  background-color: #f8f9fa;
  color: #0d6efd;
}
.class-card .class-card-options .options-menu .options-item:active, .class-card .class-card-options .options-menu .options-item:focus {
  outline: none;
  background-color: #f0f7ff;
}
.class-card .class-card-options .options-menu .options-item .option-icon {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  color: #6c757d;
}
.class-card .action-container {
  display: flex;
  justify-content: flex-start;
}
.class-card .action-container .action-buttons {
  gap: 0.5rem;
}
.class-card .action-container .btn {
  font-size: 0.85rem;
  padding: 0.35rem 1rem;
}

.enhanced-filters {
  margin-bottom: 1.5rem;
}
.enhanced-filters .filter-toggle-btn {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: var(--dark-1);
  border-radius: 6px;
  transition: all 0.2s ease;
}
.enhanced-filters .filter-toggle-btn:hover {
  background-color: #e9ecef;
}
.enhanced-filters .filter-toggle-btn svg {
  font-size: 1rem;
  color: var(--primary-color);
}
.enhanced-filters .filter-toggle-btn .badge {
  font-size: 0.7rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  background-color: var(--primary-color) !important;
}
.enhanced-filters .filter-toggle-btn .rotated {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}
.enhanced-filters .clear-filters-btn {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: none;
}
.enhanced-filters .clear-filters-btn:hover {
  text-decoration: underline;
  color: var(--primary-color-dark);
}
.enhanced-filters .filter-panel {
  margin-bottom: 1rem;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.enhanced-filters .filter-panel .card-body {
  padding: 1.25rem;
  background-color: #ffffff;
}
.enhanced-filters .filter-panel .input-group {
  margin-bottom: 1.5rem;
}
.enhanced-filters .filter-panel .input-group .input-group-text {
  background-color: white;
  border-right: none;
  color: var(--dark-2);
}
.enhanced-filters .filter-panel .input-group .input-group-text svg {
  color: var(--primary-color);
}
.enhanced-filters .filter-panel .input-group .form-control {
  border-left: none;
  font-size: 0.95rem;
}
.enhanced-filters .filter-panel .input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}
.enhanced-filters .filter-panel .input-group .btn-outline-secondary {
  border-color: #ced4da;
  color: var(--dark-2);
}
.enhanced-filters .filter-panel .input-group .btn-outline-secondary:hover {
  background-color: #f8f9fa;
}
.enhanced-filters .filter-panel .filter-category-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--dark-1);
  position: relative;
  padding-bottom: 0.5rem;
}
.enhanced-filters .filter-panel .filter-category-title:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background-color: var(--primary-color);
}
.enhanced-filters .filter-panel .filter-items-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-bottom: 1rem;
}
.enhanced-filters .filter-panel .filter-badge {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.enhanced-filters .filter-panel .filter-badge:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.enhanced-filters .filter-panel .filter-badge[bg=light] {
  background-color: #f1f3f5 !important;
  color: var(--dark-1) !important;
  border-color: #e9ecef;
}
.enhanced-filters .filter-panel .filter-badge[bg=light]:hover {
  background-color: #e9ecef !important;
  border-color: #dee2e6;
}
.enhanced-filters .filter-panel .filter-badge[bg=primary] {
  background-color: var(--primary-color) !important;
  color: white !important;
}
.enhanced-filters .filter-panel .filter-badge[bg=primary]:hover {
  background-color: var(--primary-color-dark) !important;
}
.enhanced-filters .filter-panel .filter-badge .remove-filter {
  margin-left: 0.5rem;
  font-size: 0.7rem;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.2s;
}
.enhanced-filters .filter-panel .filter-badge .remove-filter:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.enhanced-filters .filter-panel .btn {
  padding: 0.5rem 1.25rem;
  font-weight: 500;
  font-size: 0.9rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.enhanced-filters .filter-panel .btn:focus {
  box-shadow: none;
}
.enhanced-filters .filter-panel .btn-outline-danger {
  color: var(--error-color);
  border-color: var(--error-color);
}
.enhanced-filters .filter-panel .btn-outline-danger:hover {
  background-color: var(--error-color);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);
}
.enhanced-filters .filter-panel .btn-outline-secondary {
  color: var(--dark-2);
  border-color: #ced4da;
}
.enhanced-filters .filter-panel .btn-outline-secondary:hover {
  background-color: var(--dark-2);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(90, 106, 133, 0.2);
}
.enhanced-filters .filter-panel .btn-outline-primary {
  color: var(--primary-color);
  border-color: var(--primary-color);
}
.enhanced-filters .filter-panel .btn-outline-primary:hover {
  background-color: var(--primary-color);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(68, 3, 191, 0.25);
}
.enhanced-filters .active-filters {
  margin-top: 1rem;
}
.enhanced-filters .active-filters .text-muted {
  font-size: 0.85rem;
  font-weight: 500;
}
.enhanced-filters .active-filters .active-filter-badge {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.45rem 0.75rem;
  border-radius: 6px;
  background-color: #f1f3f5 !important;
  color: var(--dark-1) !important;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.enhanced-filters .active-filters .active-filter-badge:hover {
  background-color: #e9ecef !important;
  border-color: #dee2e6;
  transform: translateY(-1px);
}
.enhanced-filters .active-filters .active-filter-badge .remove-filter {
  margin-left: 0.5rem;
  font-size: 0.7rem;
  cursor: pointer;
  opacity: 0.7;
  padding: 2px;
  border-radius: 50%;
}
.enhanced-filters .active-filters .active-filter-badge .remove-filter:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
  z-index: 1050 !important;
}

@media (max-width: 768px) {
  .live-class-header .header-top {
    align-items: flex-start;
  }
  .live-class-header .header-top .header-title {
    margin-bottom: 1rem;
  }
  .live-class-tabs-container {
    padding: 0.5rem;
  }
  .live-class-tabs-container .live-class-tabs .nav-link {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
  .live-class-tabs-container .class-card-container {
    grid-template-columns: 1fr;
  }
}
/* Modern Live Class Component Styles */
.modern-class-container {
  padding: 1rem;
}
.modern-class-container .live-classes-section .section-title {
  font-weight: 600;
  position: relative;
}
.modern-class-container .live-classes-section .pulse-animation {
  animation: pulse 1.5s infinite;
}
.modern-class-container .live-classes-section .live-class-card {
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 12px;
}
.modern-class-container .live-classes-section .live-class-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
}
.modern-class-container .live-classes-section .live-class-card .live-indicator .badge {
  font-size: 0.7rem;
  letter-spacing: 0.5px;
}
.modern-class-container .live-classes-section .live-class-card .card-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.modern-class-container .live-classes-section .live-class-card .subject-badge {
  font-size: 0.65rem;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  background: #f8f9fa;
  color: #6c757d;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  display: inline-block;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.modern-class-container .live-classes-section .live-class-card .subject-badge:hover {
  background: #e9ecef;
}
.modern-class-container .live-classes-section .live-class-card .options-menu .options-toggle-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: #6c757d;
  transition: all 0.2s;
}
.modern-class-container .live-classes-section .live-class-card .options-menu .options-toggle-btn:hover {
  background-color: #f8f9fa;
  color: #343a40;
}
.modern-class-container .live-classes-section .no-live-classes i {
  color: #ddd;
  font-size: 3rem;
}
.modern-class-container .secondary-classes-section .custom-tabs-container {
  display: flex;
  gap: 1.5rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab {
  cursor: pointer;
  position: relative;
  padding: 0.75rem 0.25rem;
  font-weight: 600;
  color: #6c757d;
  transition: all 0.3s ease;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab:after {
  content: "";
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  width: 0;
  height: 3px;
  background: transparent;
  transition: all 0.3s ease;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab.active {
  color: #0d6efd;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab.active:after {
  width: 100%;
  background: #0d6efd;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab:hover:not(.active) {
  color: #495057;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab:hover:not(.active):after {
  width: 100%;
  background: #dee2e6;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .tab-label {
  margin-right: 0.25rem;
}
.modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .badge {
  vertical-align: middle;
}
.modern-class-container .secondary-classes-section .class-list-item {
  transition: all 0.2s;
  border-radius: 12px;
  overflow: visible;
  margin-bottom: 1rem;
}
.modern-class-container .secondary-classes-section .class-list-item:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
}
.modern-class-container .secondary-classes-section .class-list-item.suspended {
  opacity: 0.8;
  background-color: #f8f9fa;
  border-left: 5px solid #dc3545 !important;
  position: relative;
}
.modern-class-container .secondary-classes-section .class-list-item.suspended:after {
  content: "SUSPENDED";
  position: absolute;
  top: 0;
  right: 0;
  background-color: #dc3545;
  color: white;
  font-size: 0.7rem;
  padding: 2px 8px;
  font-weight: bold;
  letter-spacing: 0.5px;
  border-bottom-left-radius: 8px;
}
.modern-class-container .secondary-classes-section .class-list-item.suspended .class-title {
  text-decoration: line-through;
  opacity: 0.7;
}
.modern-class-container .secondary-classes-section .class-list-item .class-title {
  font-weight: 600;
  color: #343a40;
  text-overflow: ellipsis;
}
.modern-class-container .secondary-classes-section .class-list-item .status-badge {
  font-size: 0.65rem;
  padding: 0.25rem 0.5rem;
  letter-spacing: 0.5px;
}
.modern-class-container .secondary-classes-section .class-list-item .detail-group .detail-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
.modern-class-container .secondary-classes-section .class-list-item .detail-group .detail-item .detail-icon {
  width: 18px;
  height: 18px;
  color: #0d6efd;
  opacity: 0.8;
}
.modern-class-container .secondary-classes-section .class-list-item .subject-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.modern-class-container .secondary-classes-section .class-list-item .subject-tags .subject-badge {
  font-size: 0.65rem;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  background: #f8f9fa;
  color: #6c757d;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  display: inline-block;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.modern-class-container .secondary-classes-section .class-list-item .subject-tags .subject-badge:hover {
  background: #e9ecef;
}
.modern-class-container .secondary-classes-section .class-list-item .action-buttons .btn {
  margin-bottom: 0.25rem;
  border-radius: 6px;
  padding: 0.375rem 0.75rem;
  font-weight: 500;
  font-size: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}
.modern-class-container .secondary-classes-section .class-list-item .action-buttons .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.modern-class-container .secondary-classes-section .class-list-item .suspended-badge .badge,
.modern-class-container .secondary-classes-section .class-list-item .rescheduled-badge .badge {
  padding: 0.4rem 0.7rem;
  font-size: 0.75rem;
  font-weight: 500;
}
.modern-class-container .secondary-classes-section .class-list-item .options-menu .options-toggle-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: #6c757d;
  transition: all 0.2s;
}
.modern-class-container .secondary-classes-section .class-list-item .options-menu .options-toggle-btn:hover {
  background-color: #f8f9fa;
  color: #343a40;
}
.modern-class-container .secondary-classes-section .list-body {
  margin: -0.75rem;
}
@media (min-width: 1440px) {
  .modern-class-container .secondary-classes-section .list-body {
    margin: -0.6rem;
  }
}
.modern-class-container .secondary-classes-section .list-body .class-list-item {
  margin: 0.75rem;
}
@media (min-width: 1440px) {
  .modern-class-container .secondary-classes-section .list-body .class-list-item {
    margin: 0.6rem;
  }
}

/* Animation keyframes */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .modern-class-container {
    padding: 0.5rem;
  }
  .modern-class-container .live-classes-section .section-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  .modern-class-container .live-classes-section .live-class-card {
    margin-bottom: 0.75rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-body {
    padding: 0.75rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-title {
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-subtitle {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
  .modern-class-container .live-classes-section .live-class-card .class-time-info {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
  .modern-class-container .live-classes-section .live-class-card .class-time-info .detail-icon {
    width: 14px;
    height: 14px;
  }
  .modern-class-container .live-classes-section .live-class-card .subject-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .modern-class-container .live-classes-section .live-class-card .btn {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container {
    gap: 0.75rem;
    padding-bottom: 0.25rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab {
    padding: 0.5rem 0.25rem;
    font-size: 0.9rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .badge {
    font-size: 0.65rem;
    padding: 0.2rem 0.4rem;
  }
}
/* Small Mobile Optimizations (425px to 300px) */
@media (max-width: 425px) {
  .modern-class-container {
    padding: 0.25rem;
  }
  .modern-class-container .live-classes-section .section-title {
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-body {
    padding: 0.6rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-title {
    font-size: 0.9rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-subtitle {
    font-size: 0.75rem;
  }
  .modern-class-container .live-classes-section .live-class-card .class-time-info {
    font-size: 0.75rem;
  }
  .modern-class-container .live-classes-section .live-class-card .class-time-info .detail-icon {
    width: 12px;
    height: 12px;
  }
  .modern-class-container .live-classes-section .live-class-card .subject-badge {
    font-size: 0.55rem;
    padding: 0.15rem 0.3rem;
  }
  .modern-class-container .live-classes-section .live-class-card .btn {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container {
    gap: 0.5rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab {
    padding: 0.4rem 0.2rem;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .tab-label {
    font-size: 0.75rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .badge {
    font-size: 0.6rem;
    padding: 0.15rem 0.3rem;
    margin-left: 0.25rem;
  }
  .class-list-item-mobile .card-body {
    padding: 0.75rem !important;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .card-body {
    padding: 0.6rem !important;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .class-title {
    font-size: 0.9rem;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .class-title {
    font-size: 0.8rem;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .status-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .status-badge {
    font-size: 0.7rem;
    padding: 0.15rem 0.3rem;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .class-details-mobile .detail-row {
    font-size: 0.75rem;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .class-details-mobile .detail-row {
    font-size: 0.7rem;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .class-details-mobile .detail-row .detail-icon {
    width: 14px;
    height: 14px;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .class-details-mobile .detail-row .detail-icon {
    width: 12px;
    height: 12px;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .subject-tags-mobile .subject-badge {
    font-size: 0.65rem;
    padding: 0.3rem 0.5rem;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .subject-tags-mobile .subject-badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.4rem;
  }
}
@media (max-width: 425px) {
  .class-list-item-mobile .action-buttons-mobile .btn {
    font-size: 0.85rem;
    padding: 0.375rem 0.75rem;
  }
}
@media (max-width: 425px) and (min-width: 1440px) {
  .class-list-item-mobile .action-buttons-mobile .btn {
    font-size: 0.7rem;
    padding: 0.3rem 0.6rem;
  }
}
/* Extra Small Mobile Optimizations (below 390px) */
@media (max-width: 390px) {
  .modern-class-container .secondary-classes-section .custom-tabs-container {
    gap: 0.25rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab {
    padding: 0.3rem 0.15rem;
    font-size: 0.7rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .tab-label {
    font-size: 0.65rem;
  }
  .modern-class-container .secondary-classes-section .custom-tabs-container .custom-tab .badge {
    font-size: 0.55rem;
    padding: 0.1rem 0.25rem;
    margin-left: 0.2rem;
  }
}
/* Live Classes Slider Optimizations */
@media (max-width: 425px) {
  .live-classes-slider {
    padding: 0 30px;
  }
  .live-classes-slider .slider-arrow {
    width: 30px;
    height: 30px;
  }
  .live-classes-slider .slider-arrow svg {
    width: 16px;
    height: 16px;
  }
  .live-classes-slider .slider-container .row .col {
    padding: 0 8px;
  }
}

/* Additional Mobile Optimizations */
@media (max-width: 300px) {
  .modern-class-container .live-classes-section .section-title {
    font-size: 1rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-body {
    padding: 0.5rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-title {
    font-size: 0.85rem;
  }
  .modern-class-container .live-classes-section .live-class-card .card-subtitle {
    font-size: 0.7rem;
  }
  .modern-class-container .live-classes-section .live-class-card .class-time-info {
    font-size: 0.7rem;
  }
  .modern-class-container .live-classes-section .live-class-card .subject-badge {
    font-size: 0.5rem;
    padding: 0.1rem 0.25rem;
  }
  .modern-class-container .live-classes-section .live-class-card .btn {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
  .modern-class-container .class-list-item-mobile .card-body {
    padding: 0.5rem !important;
  }
  .modern-class-container .class-list-item-mobile .class-title {
    font-size: 0.85rem;
  }
  .modern-class-container .class-list-item-mobile .status-badge {
    font-size: 0.55rem;
    padding: 0.15rem 0.3rem;
  }
  .modern-class-container .class-list-item-mobile .class-details-mobile .detail-row {
    font-size: 0.7rem;
  }
  .modern-class-container .class-list-item-mobile .subject-tags-mobile .subject-badge {
    font-size: 0.5rem;
    padding: 0.1rem 0.25rem;
  }
  .modern-class-container .class-list-item-mobile .action-buttons-mobile .btn {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
}
.live-classes-slider {
  position: relative;
  padding: 0 40px;
}
@media (min-width: 992px) {
  .live-classes-slider {
    padding: 0;
    overflow: visible;
  }
}
.live-classes-slider .slider-container {
  width: 100%;
}
@media (min-width: 992px) {
  .live-classes-slider .slider-container {
    overflow: visible;
  }
}
.live-classes-slider .slider-container .row {
  margin: 0;
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-wrap: nowrap;
}
@media (min-width: 992px) {
  .live-classes-slider .slider-container .row {
    flex-wrap: wrap;
    transition: none;
  }
}
.live-classes-slider .slider-container .col {
  padding: 0 12px;
  flex: 0 0 auto;
}
@media (min-width: 992px) {
  .live-classes-slider .slider-container .col {
    flex: 0 0 auto;
  }
}
.live-classes-slider .slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  padding: 0;
}
@media (min-width: 992px) {
  .live-classes-slider .slider-arrow {
    display: none;
  }
}
.live-classes-slider .slider-arrow:hover {
  background: #f8f9fa;
}
.live-classes-slider .slider-arrow.slider-arrow-left {
  left: 0;
}
.live-classes-slider .slider-arrow.slider-arrow-right {
  right: 0;
}

/* Mobile-optimized list view styles */
.class-list-item-mobile {
  border-radius: 12px;
  transition: all 0.2s ease;
}
.class-list-item-mobile:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
}
.class-list-item-mobile.suspended {
  opacity: 0.8;
  background-color: #f8f9fa;
  border-left: 5px solid #dc3545 !important;
  position: relative;
}
.class-list-item-mobile.suspended:after {
  content: "SUSPENDED";
  position: absolute;
  top: 0;
  right: 0;
  background-color: #dc3545;
  color: white;
  font-size: 0.7rem;
  padding: 2px 8px;
  font-weight: bold;
  letter-spacing: 0.5px;
  border-bottom-left-radius: 8px;
}
.class-list-item-mobile.suspended .class-title {
  text-decoration: line-through;
  opacity: 0.7;
}
.class-list-item-mobile .card-body {
  padding: 0.75rem !important;
}
@media (min-width: 1440px) {
  .class-list-item-mobile .card-body {
    padding: 0.6rem !important;
  }
}
.class-list-item-mobile .title-container {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  min-width: 0;
}
.class-list-item-mobile .title-container .status-badge {
  flex-shrink: 0;
}
.class-list-item-mobile .title-container .title-wrapper {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.class-list-item-mobile .title-container .title-wrapper .class-title {
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}
.class-list-item-mobile .title-container .title-wrapper .options-menu {
  flex-shrink: 0;
  margin-left: auto;
}
.class-list-item-mobile .class-title {
  font-size: 0.9rem;
}
@media (min-width: 1440px) {
  .class-list-item-mobile .class-title {
    font-size: 0.8rem;
  }
}
.class-list-item-mobile .status-badge {
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
}
@media (min-width: 1440px) {
  .class-list-item-mobile .status-badge {
    font-size: 0.7rem;
    padding: 0.15rem 0.3rem;
  }
}
.class-list-item-mobile .class-details-mobile .detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  color: #495057;
}
.class-list-item-mobile .class-details-mobile .detail-row .detail-icon {
  width: 16px;
  height: 16px;
  color: #0d6efd;
  opacity: 0.8;
  flex-shrink: 0;
}
.class-list-item-mobile .class-details-mobile .detail-row span {
  color: #6c757d;
}
.class-list-item-mobile .subject-tags-mobile {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.class-list-item-mobile .subject-tags-mobile .subject-badge {
  font-size: 0.65rem;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  background: #f8f9fa;
  color: #6c757d;
  display: inline-block;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.class-list-item-mobile .subject-tags-mobile .subject-badge:hover {
  background: #e9ecef;
}
.class-list-item-mobile .action-buttons-mobile .btn {
  border-radius: 6px;
  padding: 0.375rem 0.75rem;
  font-weight: 500;
  font-size: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}
.class-list-item-mobile .action-buttons-mobile .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.class-list-item-mobile .rescheduled-badge .badge {
  font-size: 0.75rem;
  padding: 0.4rem 0.7rem;
  font-weight: 500;
}
.class-list-item-mobile .options-menu .options-toggle-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: #6c757d;
  transition: all 0.2s;
}
.class-list-item-mobile .options-menu .options-toggle-btn:hover {
  background-color: #f8f9fa;
  color: #343a40;
}

.live-classes-grid .row {
  margin: -0.75rem;
}
@media (min-width: 1440px) {
  .live-classes-grid .row {
    margin: -0.6rem;
  }
}
.live-classes-grid .col {
  padding: 0.75rem;
}
@media (min-width: 1440px) {
  .live-classes-grid .col {
    padding: 0.6rem;
  }
}

.live-class-card {
  transition: transform 0.2s ease-in-out;
}
.live-class-card:hover {
  transform: translateY(-2px);
}
.live-class-card .card-body {
  padding: 1.25rem;
}
@media (min-width: 1440px) {
  .live-class-card .card-body {
    padding: 1rem;
  }
}
.live-class-card .card-title {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
@media (min-width: 1440px) {
  .live-class-card .card-title {
    font-size: 0.8rem;
  }
}
.live-class-card .card-subtitle {
  font-size: 0.9rem;
}
@media (min-width: 1440px) {
  .live-class-card .card-subtitle {
    font-size: 0.7rem;
  }
}
.live-class-card .subject-tags .badge {
  font-size: 0.8rem;
  padding: 0.35em 0.65em;
}
@media (min-width: 1440px) {
  .live-class-card .subject-tags .badge {
    font-size: 0.7rem;
    padding: 0.4em 0.7em;
  }
}
.live-class-card .btn {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
}
@media (min-width: 1440px) {
  .live-class-card .btn {
    font-size: 0.7rem;
    padding: 0.6rem 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/theme.scss","webpack://./src/pages/Classrooms/Create/LiveClasses/components/styles.scss"],"names":[],"mappings":"AACA;EACE,gCAAA;EACA,2FAAA;EAGA,kBAAA;ACFF;ADsCA;EACE,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,uDAAA;ACxCF;;ADgDA;;;;;;EAME,oBAAA;AC7CF;;ADgDA;EACE,kBAAA;EACA,kFAAA;EAIA,uDAAA;EACA,sBAAA;AChDF;;ADmDA,kBAAA;AACA;EACE,6BAAA;AChDF;;ADmDA;EACE,sCAAA;EACA,kCAAA;AChDF;;ADmDA;EACE,kCAAA;AChDF;;ADmDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;AChDF;;ADmDA;EACE,6BAAA;AChDF;;ADmDA;EACE,oCAAA;AChDF;;ADmDA;EACE,qBAAA;EACA,0CAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AChDF;;ADmDA;EACE,uBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,4BAAA;EACA,6BAAA;AChDF;;ADmDA,+BAAA;AACA;EACE,aAAA;AChDF;;ADmDA,kBAAA;AACA;EACE,+BAAA;EACA,6BAAA;AChDF;;ADmDA;EACE,kBAAA;EACA,+BAAA;AChDF;;ADmDA,gBAAA;AACA;EACE,wCAAA;EACA,2BAAA;AChDF;;ADmDA,mBAAA;AACA;EACE,6BAAA;EACA,+BAAA;EACA,YAAA;AChDF;;ADmDA,8DAAA;AAEA;EACE,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;ACjDF;;ADoDA;EACE,WAAA;ACjDF;;ADoDA;EACE,YAAA;EACA,UAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,gCAAA;ACjDF;;ADoDA;EACE,aAAA;ACjDF;;ADoDA;EACE,WAAA;ACjDF;;ADoDA;EACE,WAAA;EACA,eAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,qBAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,qBAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,qBAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,qBAAA;ACjDF;;ADoDA;;;;EAIE,yBAAA;EACA,6CAAA;ACjDF;;ADqDA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AClDF;;ADqDA;EACE,sBAAA;EACA,mCAAA;EACA,eAAA;EACA,4BAAA;AClDF;;ADqDA;EACE,gCAAA;EACA,WAAA;EACA,yCAAA;EACA,UAAA;AClDF;;ADqDA,sEAAA;AAEA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;EACA,gCAAA;EACA,aAAA;EACA,kCAAA;ACnDF;;ADsDA;EACE,YAAA;ACnDF;;ADsDA,8DAAA;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,sDAAA;EACA,0BAAA;EACA,0CAAA;ACpDF;;ADuDA;EACE,6BAAA;EACA,YAAA;ACpDF;;ADuDA;EACE,6BAAA;EACA,0BAAA;EACA,YAAA;ACpDF;;ADuDA;EACE,kBAAA;EACA,SAAA;EACA,0CAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,uCAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gDAAA;ACpDF;;ADuDA;EACE,wBAAA;EACA,uBAAA;ACpDF;;ADuDA;EACE,yBAAA;ACpDF;;ADuDA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;ACpDF;;ADuDA;EACE,0BAAA;ACpDF;;ADuDA;EACE,0BAAA;ACpDF;;ADuDA;EACE,UAAA;EACA,gBAAA;ACpDF;;ADuDA;EACE,YAAA;EACA,mBAAA;ACpDF;;ADuDA;EACE,qBAAA;EACA,YAAA;ACpDF;;ADuDA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;ACpDF;;ADyDA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;ACtDF;;ADyDA;EACE,uBAAA;EACA,0BAAA;ACtDF;;ADyDA;EACE,uBAAA;EACA,yBAAA;ACtDF;;ADyDA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;ACtDF;;ADyDA;EACE,oCAAA;ACtDF;;ADyDA;EACE,cApYO;AC8UT;;ADyDA;EACE,8BAAA;ACtDF;;ADyDA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ACtDF;;AD2DA,qBAAA;AACA;EACE,aAAA;EACA,iBAAA;ACxDF;;AD2DA;EACE,mBAAA;EACA,gBAAA;ACxDF;;AD2DA;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;ACxDF;;AD2DA;EACE,UAAA;ACxDF;;AD2DA;EACE,UAAA;ACxDF;;AD2DA;EACE,aAAA;ACxDF;;AD2DA;EACE,aAAA;ACxDF;;AD2DA;EAEE,mBAAA;ACzDF;;AD4DA;EACE,SAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;ACzDF;;AD4DA;EACE,eAAA;EACA,cAAA;EACA,cArdO;AC4ZT;;AD4DA,+DAAA;AACA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,cA5ec;ACmbhB;;AD4DA;EACE,cAxeW;AC+ab;;AD4DA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAvfgB;EAwfhB,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,cA/eO;EAgfP,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,8CAAA;EACA,eAAA;EACA,kBAAA;ACzDF;;AD4DA;EACE,kBAAA;ACzDF;;AD4DA;EACE,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cA/gBc;ACsdhB;;AD4DA;EACE,2DAAA;EACA,eAAA;ACzDF;;AD4DA;EACE,gCAAA;EACA,cAzhBc;ACgehB;;AD4DA;EACE,uBAAA;ACzDF;;AD4DA;EACE,uBAAA;EACA,SAAA;ACzDF;;AD4DA;EACE,oBAAA;ACzDF;;AD4DA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;ACzDF;;AD4DA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;ACzDF;;AD4DA;EACE,sBAAA;ACzDF;;AD4DA;EACE,sBAAA;ACzDF;;AD4DA;EACE,WAAA;ACzDF;;AD4DA;EACE,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,cA1kBa;ACihBf;;AD4DA;EACE,aAAA;EACA,8BAAA;ACzDF;;AD4DA;EACE,oCAAA;ACzDF;;AD4DA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ACzDF;;AD4DA;EACE,4CAAA;EACA,kBAAA;ACzDF;;AD4DA;EACE,uBAAA;EACA,4BAAA;ACzDF;;AD4DA;EACE,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;ACzDF;;AD4DA;EACE,kBAAA;EACA,6BAAA;ACzDF;;AD4DA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;ACzDF;;AD4DA;EACE,oCAAA;ACzDF;;ADgEA;EACE,sBAAA;EACA,uBAAA;AC7DF;;ADgEA;EACE,eAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC7DF;;ADgEA;EACE,uBAAA;EACA,yCAAA;AC7DF;;ADgEA;EACE,uBAAA;AC7DF;;ADgEA;EACE,aAAA;AC7DF;;ADgEA;EACE,wBAAA;AC7DF;;ADgEA;EACE,oBAAA;AC7DF;;ADgEA;EACE,oBAAA;AC7DF;;ADgEA;EACE,wBAAA;AC7DF;;ADgEA;EACE,kBAAA;EACA,yBAAA;AC7DF;;ADgEA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AC7DF;;ADgEA;EACE,cAAA;AC7DF;;ADgEA;EACE,sBAAA;EACA,qBAAA;AC7DF;;ADgEA;EACE,6BAAA;AC7DF;;ADgEA;EACE,YAAA;EACA,wCAAA;AC7DF;;ADgEA;EACE,oEAAA;EACA,2DAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,uBAAA;EACA,mCAAA;AC7DF;;ADgEA;EACE,WAAA;EACA,YAAA;AC7DF;;ADgEA;EACE,4BAAA;AC7DF;;ADgEA;EAEE,QAAA;EACA,iBAAA;AC9DF;;ADiEA;EACE,uBAAA;EAAA,kBAAA;AC9DF;;ADkEA;EACE,eAAA;AC/DF;;ADkEA,yCAAA;AACA;EACE;IACE,aAAA;EC/DF;EDkEA;IACE,0BAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EChEF;EDmEA;IACE,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;ECjEF;EDoEA;IACE,yBAAA;IACA,6BAAA;IACA,oBAAA;EClEF;EDqEA;IACE,sBAAA;ECnEF;EDsEA;IACE,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;ECpEF;EDuEA;IACE,eAAA;ECrEF;EDwEA;IACE,eAAA;ECtEF;EDyEA;IACE,qBAAA;IACA,eAAA;IACA,YAAA;IACA,aAAA;ECvEF;ED0EA;IACE,qBAAA;IACA,eAAA;IACA,aAAA;IACA,aAAA;ECxEF;ED2EA;IACE,sBAAA;ECzEF;ED4EA;IACE,SAAA;EC1EF;ED6EA;IACE,YAAA;IACA,eAAA;IACA,uBAAA;IACA,2BAAA;IACA,mBAAA;IACA,UAAA;IACA,oBAAA;EC3EF;ED8EA;IACE,sBAAA;EC5EF;ED+EA;IACE,sBAAA;EC7EF;EDgFA;IACE,uBAAA;EC9EF;EDiFA;IACE,uBAAA;EC/EF;EDiFA;IACE,YAAA;IACA,gBAAA;EC/EF;AACF;AD+EI;EAHF;IAII,YAAA;EC5EJ;AACF;ADrBA;EAoGE;IACE,yBAAA;EC5EF;ED+EA;IACE,wBAAA;EC7EF;EDgFA;IACE,qBAAA;EC9EF;EDiFA;IACE,uBAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,sCAAA;EC/EF;AACF;ADkFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;EChFF;AACF;ADmFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;ECjFF;AACF;ADoFA;EACE;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qCAAA;EClFF;AACF;ADqFA;EACE,aAAA;EACA,mBAAA;ACnFF;;ADqFA;EACE,iCAAA,EAAA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AClFF;;ADoFA;EACE,2BAAA;EACA,uBAAA;EACA,UAAA;ACjFF;;ADoFA;EACE,8BAAA;ACjFF;;ADoFA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;ACjFF;;ADoFA;EACE,eAAA;EACA,sBAAA;ACjFF;;ADoFA;EACE,UAAA;EACA,oBAAA;ACjFF;;ADoFA;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;ACjFF;;ADoFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;ACjFF;;ADoFA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ACjFF;;ADoFA;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;ACjFF;;ADoFA;EACE,yBAAA;EACA,WAAA;ACjFF;;ADoFA;EACE,uBAAA;EACA,kBAAA;EACA,SAAA;ACjFF;;ADoFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;ACjFF;;ADoFA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EAAA,gCAAA;EAAA,8DAAA;ACjFF;;ADoFA;EACE,0BAAA;ACjFF;;ADqFA;EACE,2BAAA;EACA,aAAA;AClFF;;ADqFA;EACE,2BAAA;EACA,gBAAA;EACA,iBAAA;AClFF;;AAl8BA;EACE,qBAAA;AAq8BF;AAn8BE;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAq8BJ;AAn8BI;EARF;IASI,qBAAA;IACA,YAAA;EAs8BJ;AACF;AAp8BI;EAbF;IAcI,uBAAA;IACA,WAAA;EAu8BJ;AACF;AAr8BI;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AAu8BN;AAr8BM;EAPF;IAQI,kBAAA;EAw8BN;AACF;AAt8BM;EAXF;IAYI,iBAAA;EAy8BN;AACF;AAt8BI;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAw8BN;AAt8BM;EANF;IAOI,WAAA;EAy8BN;AACF;AAv8BM;EAVF;IAWI,YAAA;EA08BN;AACF;AAx8BM;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AA08BR;AAx8BQ;EANF;IAOI,WAAA;EA28BR;AACF;AAz8BQ;EAVF;IAWI,YAAA;EA48BR;AACF;AA18BQ;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AA48BV;AA18BU;EAPF;IAQI,kBAAA;IACA,uBAAA;EA68BV;AACF;AA38BU;EAZF;IAaI,iBAAA;IACA,uBAAA;EA88BV;AACF;AA58BU;EACE,2BAAA;EACA,wCAAA;AA88BZ;AAx8BU;EACE;IACE,kBAAA;IACA,uBAAA;EA08BZ;AACF;AAv8BU;EACE;IACE,iBAAA;IACA,uBAAA;EAy8BZ;AACF;AAl8BE;EACE,iBAAA;AAo8BJ;AAl8BI;EAHF;IAII,kBAAA;EAq8BJ;AACF;AAn8BI;EAPF;IAQI,iBAAA;EAs8BJ;AACF;;AAj8BA;EACE,sBAAA;EACA,kBAAA;AAo8BF;AAl8BE;EACE,uCAAA;AAo8BJ;AAl8BI;EACE,mBAAA;EACA,iBAAA;AAo8BN;AAj8BI;EACE,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gCAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAk8BN;AAh8BM;EACE,gCAAA;EACA,oBAAA;AAk8BR;AA/7BM;EACE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;AAi8BR;AA/7BQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EAEA,2BAAA;EACA,4BAAA;AAg8BV;AA57BM;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA87BR;AAx7BE;EACE,kBAAA;EACA,iBAAA;EACA,4BAAA;AA07BJ;AAv7BE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,4BAAA;AAy7BJ;AAv7BI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AAy7BN;AAr7BE;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAu7BJ;AAp7BE;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;AAs7BJ;;AAj7BA;EACE,kBAAA;EACA,gCAAA;EACA,yCAAA;EACA,2CAAA;EACA,4BAAA;EACA,kBAAA;AAo7BF;AA36BE;EACE,yCAAA;AA66BJ;AA16BE;EACE,wCAAA;AA46BJ;AAz6BE;EACE,oCAAA;AA26BJ;AAx6BE;EACE,YAAA;EACA,gCAAA;AA06BJ;AAv6BE;EACE,aAAA;EACA,4BAAA;AAy6BJ;AAr6BE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAu6BJ;AAr6BI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAu6BN;AAp6BI;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;AAs6BN;AAj6BE;EACE,sBAAA;AAm6BJ;AAj6BI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAm6BN;AAj6BM;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;AAm6BR;AA/5BI;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAi6BN;AA/5BM;EACE,iBAAA;EACA,gCAAA;EACA,oBAAA;EACA,uBAAA;AAi6BR;AA35BE;;EAEE,kBAAA;AA65BJ;AA35BI;;EACE,kBAAA;EACA,uBAAA;AA85BN;AAz5BE;EACE,kBAAA;AA25BJ;AAv5BE;EACE,kBAAA;AAy5BJ;AAv5BI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAy5BN;AAv5BM;EACE,yBAAA;EACA,cAAA;EACA,cAAA;AAy5BR;AAr5BI;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;AAu5BN;AAr5BM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAu5BR;AAr5BQ;EACE,yBAAA;EACA,cAAA;AAu5BV;AAp5BQ;EAEE,aAAA;EACA,yBAAA;AAq5BV;AAl5BQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAo5BV;AA74BE;EACE,aAAA;EACA,2BAAA;AA+4BJ;AA74BI;EACE,WAAA;AA+4BN;AA54BI;EACE,kBAAA;EACA,qBAAA;AA84BN;;AAx4BA;EACE,qBAAA;AA24BF;AAz4BE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AA24BJ;AAz4BI;EACE,yBAAA;AA24BN;AAx4BI;EACE,eAAA;EACA,2BAAA;AA04BN;AAv4BI;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDAAA;AAy4BN;AAt4BI;EACE,yBAAA;EACA,+BAAA;AAw4BN;AAp4BE;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;AAs4BJ;AAp4BI;EACE,0BAAA;EACA,gCAAA;AAs4BN;AAl4BE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;AAo4BJ;AAj4BI;EACE,gBAAA;EACA,yBAAA;AAm4BN;AA/3BI;EACE,qBAAA;AAi4BN;AA/3BM;EACE,uBAAA;EACA,kBAAA;EACA,oBAAA;AAi4BR;AA/3BQ;EACE,2BAAA;AAi4BV;AA73BM;EACE,iBAAA;EACA,kBAAA;AA+3BR;AA73BQ;EACE,gBAAA;EACA,qBAAA;AA+3BV;AA33BM;EACE,qBAAA;EACA,oBAAA;AA63BR;AA33BQ;EACE,yBAAA;AA63BV;AAx3BI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AA03BN;AAx3BM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;AA03BR;AAt3BI;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAw3BN;AAr3BI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;AAu3BN;AAr3BM;EACE,YAAA;EACA,2BAAA;AAu3BR;AAp3BM;EACE,oCAAA;EACA,+BAAA;EACA,qBAAA;AAs3BR;AAp3BQ;EACE,oCAAA;EACA,qBAAA;AAs3BV;AAl3BM;EACE,iDAAA;EACA,uBAAA;AAo3BR;AAl3BQ;EACE,sDAAA;AAo3BV;AAh3BM;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAk3BR;AAh3BQ;EACE,0CAAA;AAk3BV;AA52BI;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA82BN;AA52BM;EACE,gBAAA;AA82BR;AA12BI;EACE,yBAAA;EACA,gCAAA;AA42BN;AA12BM;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;EACA,4CAAA;AA42BR;AAx2BI;EACE,oBAAA;EACA,qBAAA;AA02BN;AAx2BM;EACE,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;AA02BR;AAt2BI;EACE,2BAAA;EACA,kCAAA;AAw2BN;AAt2BM;EACE,sCAAA;EACA,YAAA;EACA,2BAAA;EACA,4CAAA;AAw2BR;AAn2BE;EACE,gBAAA;AAq2BJ;AAn2BI;EACE,kBAAA;EACA,gBAAA;AAq2BN;AAl2BI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oCAAA;EACA,+BAAA;EACA,yBAAA;EACA,yBAAA;AAo2BN;AAl2BM;EACE,oCAAA;EACA,qBAAA;EACA,2BAAA;AAo2BR;AAj2BM;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAm2BR;AAj2BQ;EACE,UAAA;EACA,oCAAA;AAm2BV;;AA31BA;EACE,wBAAA;AA81BF;;AA11BA;EAEI;IAEE,uBAAA;EA21BJ;EAz1BI;IACE,mBAAA;EA21BN;EAt1BA;IACE,eAAA;EAw1BF;EAr1BI;IACE,uBAAA;IACA,kBAAA;EAu1BN;EAn1BE;IACE,0BAAA;EAq1BJ;AACF;AAj1BA,uCAAA;AAEA;EACE,aAAA;AAk1BF;AA/0BI;EACE,gBAAA;EACA,kBAAA;AAi1BN;AA90BI;EACE,8BAAA;AAg1BN;AA70BI;EACE,2CAAA;EACA,mBAAA;AA+0BN;AA70BM;EACE,2BAAA;EACA,qDAAA;AA+0BR;AA30BQ;EACE,iBAAA;EACA,qBAAA;AA60BV;AAz0BM;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,uBAAA;AA00BR;AAv0BM;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yCAAA;AAy0BR;AAv0BQ;EACE,mBAAA;AAy0BV;AAp0BQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAs0BV;AAp0BU;EACE,yBAAA;EACA,cAAA;AAs0BZ;AA/zBM;EACE,WAAA;EACA,eAAA;AAi0BR;AA1zBI;EACE,aAAA;EACA,WAAA;EACA,gCAAA;EACA,sBAAA;AA4zBN;AA1zBM;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA4zBR;AA1zBQ;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;AA4zBV;AAzzBQ;EACE,cAAA;AA2zBV;AAzzBU;EACE,WAAA;EACA,mBAAA;AA2zBZ;AAvzBQ;EACE,cAAA;AAyzBV;AAvzBU;EACE,WAAA;EACA,mBAAA;AAyzBZ;AArzBQ;EACE,qBAAA;AAuzBV;AApzBQ;EACE,sBAAA;AAszBV;AAhzBI;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAkzBN;AAhzBM;EAEE,qDAAA;AAizBR;AA9yBM;EACE,YAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AAgzBR;AA9yBQ;EACE,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;AAgzBV;AA7yBQ;EACE,6BAAA;EACA,YAAA;AA+yBV;AA3yBM;EACE,gBAAA;EACA,cAAA;EAEA,uBAAA;AA4yBR;AAzyBM;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;AA2yBR;AAvyBQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAyyBV;AAvyBU;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAyyBZ;AApyBM;EACE,aAAA;EACA,eAAA;EACA,yBAAA;AAsyBR;AApyBQ;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yCAAA;AAsyBV;AApyBU;EACE,mBAAA;AAsyBZ;AAhyBQ;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,oBAAA;AAkyBV;AAhyBU;EACE,2BAAA;EACA,wCAAA;AAkyBZ;AA3xBQ;;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AA8xBV;AAzxBQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AA2xBV;AAzxBU;EACE,yBAAA;EACA,cAAA;AA2xBZ;AArxBI;EACE,gBAAA;AAuxBN;AArxBM;EAHF;IAII,eAAA;EAwxBN;AACF;AAtxBM;EACE,eAAA;AAwxBR;AAtxBQ;EAHF;IAII,cAAA;EAyxBR;AACF;;AAnxBA,wBAAA;AACA;EACE;IACE,mBAAA;IACA,UAAA;EAsxBF;EApxBA;IACE,sBAAA;IACA,YAAA;EAsxBF;EApxBA;IACE,mBAAA;IACA,UAAA;EAsxBF;AACF;AAnxBA,2BAAA;AACA;EACE;IACE,eAAA;EAqxBF;EAlxBI;IACE,kBAAA;IACA,mBAAA;EAoxBN;EAjxBI;IACE,sBAAA;EAmxBN;EAjxBM;IACE,gBAAA;EAmxBR;EAhxBM;IACE,kBAAA;IACA,sBAAA;EAkxBR;EA/wBM;IACE,iBAAA;IACA,qBAAA;EAixBR;EA9wBM;IACE,iBAAA;IACA,qBAAA;EAgxBR;EA9wBQ;IACE,WAAA;IACA,YAAA;EAgxBV;EA5wBM;IACE,iBAAA;IACA,sBAAA;IACA,oBAAA;IACA,qBAAA;EA8wBR;EA3wBM;IACE,iBAAA;IACA,sBAAA;EA6wBR;EAvwBI;IACE,YAAA;IACA,uBAAA;EAywBN;EAvwBM;IACE,uBAAA;IACA,iBAAA;EAywBR;EAvwBQ;IACE,kBAAA;IACA,sBAAA;EAywBV;AACF;AAlwBA,gDAAA;AACA;EACE;IACE,gBAAA;EAowBF;EAjwBI;IACE,iBAAA;IACA,sBAAA;EAmwBN;EA/vBM;IACE,eAAA;EAiwBR;EA9vBM;IACE,iBAAA;EAgwBR;EA7vBM;IACE,kBAAA;EA+vBR;EA5vBM;IACE,kBAAA;EA8vBR;EA5vBQ;IACE,WAAA;IACA,YAAA;EA8vBV;EA1vBM;IACE,kBAAA;IACA,uBAAA;EA4vBR;EAzvBM;IACE,kBAAA;IACA,uBAAA;EA2vBR;EArvBI;IACE,WAAA;EAuvBN;EArvBM;IACE,sBAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;EAuvBR;EArvBQ;IACE,kBAAA;EAuvBV;EApvBQ;IACE,iBAAA;IACA,uBAAA;IACA,oBAAA;EAsvBV;EA9uBE;IACE,2BAAA;EAgvBJ;AACF;AA/uBM;EAHF;IAII,0BAAA;EAkvBN;AACF;AA9zBA;EA+EI;IACE,iBAAA;EAkvBJ;AACF;AAjvBM;EAHF;IAII,iBAAA;EAovBN;AACF;AAx0BA;EAuFI;IACE,iBAAA;IACA,sBAAA;EAovBJ;AACF;AAnvBM;EAJF;IAKI,iBAAA;IACA,uBAAA;EAsvBN;AACF;AAp1BA;EAkGM;IACE,kBAAA;EAqvBN;AACF;AApvBQ;EAHF;IAII,iBAAA;EAuvBR;AACF;AA91BA;EAyGQ;IACE,WAAA;IACA,YAAA;EAwvBR;AACF;AAvvBU;EAJF;IAKI,WAAA;IACA,YAAA;EA0vBV;AACF;AA12BA;EAsHM;IACE,kBAAA;IACA,sBAAA;EAuvBN;AACF;AAtvBQ;EAJF;IAKI,iBAAA;IACA,uBAAA;EAyvBR;AACF;AAt3BA;EAkIM;IACE,kBAAA;IACA,yBAAA;EAuvBN;AACF;AAtvBQ;EAJF;IAKI,iBAAA;IACA,sBAAA;EAyvBR;AACF;AAnvBA,mDAAA;AACA;EAGM;IACE,YAAA;EAmvBN;EAjvBM;IACE,uBAAA;IACA,iBAAA;EAmvBR;EAjvBQ;IACE,kBAAA;EAmvBV;EAhvBQ;IACE,kBAAA;IACA,uBAAA;IACA,mBAAA;EAkvBV;AACF;AA3uBA,sCAAA;AAEE;EADF;IAEI,eAAA;EA6uBF;EA3uBE;IACE,WAAA;IACA,YAAA;EA6uBJ;EA3uBI;IACE,WAAA;IACA,YAAA;EA6uBN;EAvuBM;IACE,cAAA;EAyuBR;AACF;;AAnuBA,oCAAA;AACA;EAGM;IACE,eAAA;EAouBN;EAhuBM;IACE,eAAA;EAkuBR;EA/tBM;IACE,kBAAA;EAiuBR;EA9tBM;IACE,iBAAA;EAguBR;EA7tBM;IACE,iBAAA;EA+tBR;EA5tBM;IACE,iBAAA;IACA,uBAAA;EA8tBR;EA3tBM;IACE,iBAAA;IACA,sBAAA;EA6tBR;EAvtBI;IACE,0BAAA;EAytBN;EAttBI;IACE,kBAAA;EAwtBN;EArtBI;IACE,kBAAA;IACA,uBAAA;EAutBN;EAntBM;IACE,iBAAA;EAqtBR;EAhtBM;IACE,iBAAA;IACA,uBAAA;EAktBR;EA7sBM;IACE,iBAAA;IACA,sBAAA;EA+sBR;AACF;AAzsBA;EACE,kBAAA;EAEA,eAAA;AA0sBF;AAxsBE;EALF;IAMI,UAAA;IACA,iBAAA;EA2sBF;AACF;AAzsBE;EAEE,WAAA;AA0sBJ;AAxsBI;EAJF;IAKI,iBAAA;EA2sBJ;AACF;AAzsBI;EACE,SAAA;EACA,sCAAA;EACA,aAAA;EACA,iBAAA;AA2sBN;AAzsBM;EANF;IAOI,eAAA;IACA,gBAAA;EA4sBN;AACF;AAzsBI;EACE,eAAA;EACA,cAAA;AA2sBN;AAzsBM;EAJF;IAKI,cAAA;EA4sBN;AACF;AAxsBE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wCAAA;EACA,yBAAA;EACA,UAAA;AA0sBJ;AAxsBI;EAhBF;IAiBI,aAAA;EA2sBJ;AACF;AAzsBI;EACE,mBAAA;AA2sBN;AAxsBI;EACE,OAAA;AA0sBN;AAvsBI;EACE,QAAA;AAysBN;;AApsBA,sCAAA;AACA;EACE,mBAAA;EACA,yBAAA;AAusBF;AArsBE;EACE,2BAAA;EACA,qDAAA;AAusBJ;AApsBE;EACE,YAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AAssBJ;AApsBI;EACE,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;AAssBN;AAnsBI;EACE,6BAAA;EACA,YAAA;AAqsBN;AAjsBE;EACE,2BAAA;AAmsBJ;AAjsBI;EAHF;IAII,0BAAA;EAosBJ;AACF;AAjsBE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;AAmsBJ;AAjsBI;EACE,cAAA;AAmsBN;AAhsBI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAksBN;AAhsBM;EACE,SAAA;EACA,mBAAA;EAEA,uBAAA;EACA,SAAA;EACA,YAAA;AAisBR;AA9rBM;EACE,cAAA;EACA,iBAAA;AAgsBR;AA3rBE;EACE,iBAAA;AA6rBJ;AA3rBI;EAHF;IAII,iBAAA;EA8rBJ;AACF;AA3rBE;EACE,iBAAA;EACA,sBAAA;AA6rBJ;AA3rBI;EAJF;IAKI,iBAAA;IACA,uBAAA;EA8rBJ;AACF;AA1rBI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AA4rBN;AA1rBM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AA4rBR;AAzrBM;EACE,cAAA;AA2rBR;AAtrBE;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAwrBJ;AAtrBI;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,yCAAA;AAwrBN;AAtrBM;EACE,mBAAA;AAwrBR;AAlrBI;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,oBAAA;AAorBN;AAlrBM;EACE,2BAAA;EACA,wCAAA;AAorBR;AA9qBI;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;AAgrBN;AA3qBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AA6qBN;AA3qBM;EACE,yBAAA;EACA,cAAA;AA6qBR;;AArqBE;EACE,gBAAA;AAwqBJ;AAtqBI;EAHF;IAII,eAAA;EAyqBJ;AACF;AAtqBE;EACE,gBAAA;AAwqBJ;AAtqBI;EAHF;IAII,eAAA;EAyqBJ;AACF;;AArqBA;EACE,sCAAA;AAwqBF;AAtqBE;EACE,2BAAA;AAwqBJ;AArqBE;EACE,gBAAA;AAuqBJ;AArqBI;EAHF;IAII,aAAA;EAwqBJ;AACF;AArqBE;EACE,iBAAA;EACA,qBAAA;AAuqBJ;AArqBI;EAJF;IAKI,iBAAA;EAwqBJ;AACF;AArqBE;EACE,iBAAA;AAuqBJ;AArqBI;EAHF;IAII,iBAAA;EAwqBJ;AACF;AApqBI;EACE,iBAAA;EACA,sBAAA;AAsqBN;AApqBM;EAJF;IAKI,iBAAA;IACA,oBAAA;EAuqBN;AACF;AAnqBE;EACE,iBAAA;EACA,oBAAA;AAqqBJ;AAnqBI;EAJF;IAKI,iBAAA;IACA,sBAAA;EAsqBJ;AACF","sourcesContent":["// styles/theme.scss\n@font-face {\n  font-family: \"Plus Jakarta Sans\";\n  src: local(\"Plus Jakarta Sans\"),\n    url(\"../../public/assets/fonts/PlusJakartaSans-VariableFont_wght.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n\n$font-family: \"Plus Jakarta Sans\", sans-serif;\n\n// Brand Colors\n$primary-color: #4403bf;\n$secondary-color: #fff;\n$darker-color: #290273;\n$lighter-color: #9275ed;\n$subtle-color: #d3c8ff;\n\n// State Colors\n$success-color: #06c270;\n$info-color: #0063f7;\n$warning-color: #ffcc00;\n$error-color: #ff3b3b;\n\n// Dark Colors\n$dark-1: #3a3a3c;\n$dark-2: #6b7588;\n$dark-3: #8f90a6;\n$dark-4: #c7c9d9;\n\n// Light Colors\n$light-1: #dde5e9;\n$light-2: #ebebf0;\n$light-3: #f2f2f5;\n$light-4: #fafafc;\n\n$font-regular: 400;\n$font-medium: 500;\n$font-semi-bold: 600;\n$font-bold: 700;\n\n// :root\n:root {\n  --primary-color: #4403bf;\n  --secondary-color: #fff;\n  --darker-color: #290273;\n  --lighter-color: #9275ed;\n  --subtle-color: #d3c8ff;\n\n  --success-color: #06c270;\n  --info-color: #0063f7;\n  --warning-color: #ffcc00;\n  --error-color: #ff3b3b;\n\n  --dark-1: #3a3a3c;\n  --dark-2: #6b7588;\n  --dark-3: #8f90a6;\n  --dark-4: #c7c9d9;\n\n  --light-1: #dde5e9;\n  --light-2: #ebebf0;\n  --light-3: #f2f2f5;\n  --light-4: #fafafc;\n\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n$theme-colors: (\n  primary: $primary-color,\n  secondary: $secondary-color,\n);\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0 !important;\n}\n\nbody {\n  --bs-bg-opacity: 1;\n  background-color: rgba(\n    var(--bs-tertiary-bg-rgb),\n    var(--bs-bg-opacity)\n  ) !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n  padding: 0% !important;\n}\n\n/* Button Styles */\n.btn {\n  color: var(--secondary-color);\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.top-screen-navbar {\n  background-color: white !important;\n}\n\n.sticky-sidebar-styles {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 16.6666667%;\n  overflow-y: auto;\n  z-index: 100;\n  align-items: flex-start;\n  height: 100%;\n  background-color: var(--dark-1);\n}\n\n.navlink-styles {\n  padding-left: 18px !important;\n}\n\n.selected-sidebar-link {\n  background-color: #4403bf !important;\n}\n\n.offcanvas {\n  width: 70% !important;\n  background-color: var(--dark-1) !important;\n  color: white !important;\n  z-index: 2;\n  padding-left: 0px;\n}\n\n.discussion-color {\n  color: white !important;\n}\n\n.sel-discussion-color {\n  color: #4403bf !important;\n}\n\n.sel-discussion-color:hover {\n  color: #4403bf !important;\n}\n\n.offcanvas-body {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n/* Define the scrollbar style */\n.sticky-sidebar-styles::-webkit-scrollbar {\n  display: none;\n}\n\n/* Header Styles */\n.navbar {\n  background-color: var(--dark-1);\n  color: var(--secondary-color);\n}\n\n.custom-margin-right {\n  margin-right: 10px;\n  /* Adjust the value as needed */\n}\n\n/* Card Styles */\n.card {\n  background-color: var(--secondary-color);\n  color: var(--primary-color);\n}\n\n/* Sidebar Styles */\n.sidebar {\n  color: var(--secondary-color);\n  background-color: var(--dark-1);\n  height: auto;\n}\n\n/* Add these styles in your CSS or use a separate stylesheet */\n\n.sidebar-container {\n  background-color: #343a40;\n  /* Dark background color */\n  height: 100vh;\n  overflow-x: hidden;\n  width: 250px;\n  /* Adjust the width as needed */\n  position: fixed;\n  transition: width 0.3s;\n  /* Add transition for smoother animation */\n}\n\n.sidebar-container .navbar {\n  width: 100%;\n}\n\n.sidebar-container .navbar-toggler {\n  border: none;\n  padding: 0;\n}\n\n.sidebar-container .navbar-toggler-icon {\n  background-color: #fff;\n  /* Color of the hamburger icon */\n}\n\n.sidebar-container .navbar-collapse {\n  padding: 20px;\n}\n\n.sidebar-container .navbar-nav {\n  width: 100%;\n}\n\n.sidebar-container .nav-link {\n  color: #fff;\n  /* Text color */\n}\n\n.nav-link:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div div:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.nav-link div div svg:hover {\n  color: #fff !important;\n  /* Hover text color */\n}\n\n.sidebar-container .navbar-nav .active > .nav-link,\n.sidebar-container .navbar-nav .nav-link.active,\n.sidebar-container .navbar-nav .nav-link.show,\n.sidebar-container .navbar-nav .show > .nav-link {\n  background-color: #495057;\n  /* Background color for active/hovered link */\n}\n\n// Add this in your styles/theme.scss or a separate CSS file\n.navbar .nav-link.heading::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1px;\n  /* Adjust the height of the line as needed */\n  background-color: #6e6e6f;\n  /* Use the appropriate color */\n  opacity: 10;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.sidebar-item {\n  transition: color 0.3s;\n  /* Add a smooth transition effect */\n  cursor: pointer;\n  /* Change cursor to a hand */\n}\n\n.sidebar-item:hover {\n  /* Bright white color on hover */\n  color: #fff;\n  /* Change text color on hover if needed */\n  opacity: 1;\n}\n\n/* Add these styles in your styles/theme.scss or a separate CSS file */\n\n.mobile-view {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: var(--light-4);\n  /* Adjust this color as needed */\n  padding: 10px;\n  /* Adjust this padding as needed */\n}\n\n.mobile-view .nav-link {\n  flex-grow: 1;\n}\n\n/* Add these styles in your CSS or use a separate stylesheet */\n\n.sidebar-item .dropdown-arrow {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 6px 6px 0 6px;\n  border-color: #fff transparent transparent transparent;\n  transition: transform 0.3s;\n  /* Add transition for smoother animation */\n}\n\n.logout-dropdown .dropdown-menu.show {\n  position: absolute !important;\n  left: -147px;\n}\n\n.questionBank .dropdown-menu {\n  position: relative !important;\n  transform: none !important;\n  border: none;\n}\n\n.sidebar-item .dropdown-menu {\n  position: absolute;\n  top: 100%;\n  /* Adjust positioning to prevent overlap */\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  background-color: #343a40;\n  /* Dark background color */\n  transition: max-height 0.3s ease-in-out;\n  /* Add transition for smoother animation */\n  max-height: 0;\n  overflow: hidden;\n  z-index: 1;\n  /* Ensure the dropdown is above other elements */\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n  /* Hide default arrow */\n}\n\n.sidebar-item:hover .custom-arrow {\n  transform: rotate(180deg);\n}\n\n.coursework-sidebar {\n  width: 100%;\n  background-color: white;\n  height: 100%;\n  color: black;\n  border: 1px solid lightgrey;\n}\n\n.coursework-content {\n  padding: 10px 0px 0px 20px;\n}\n\n.coursework-heading {\n  padding: 25px 0px 0px 20px;\n}\n\n.coursework-sidebar ul {\n  padding: 0;\n  list-style: none;\n}\n\n.coursework-sidebar li {\n  padding: 2px;\n  margin-bottom: 10px;\n}\n\n.coursework-sidebar li a {\n  text-decoration: none;\n  color: black;\n}\n\n.profile_main_div {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n$input-placeholder-color: $dark-4;\n\n.react-tel-input .form-control {\n  width: 100% !important;\n  height: 42px !important;\n  font-size: 16px !important;\n}\n\n.right-side .form-control {\n  height: 42px !important;\n  font-size: 16px !important;\n}\n\n.right-side .input-group {\n  height: 42px !important;\n  border: 1px solid #e9eaf0;\n}\n\n.input-style {\n  padding: 8px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  line-height: 1.5 !important;\n}\n\n.form-check-input:checked {\n  background-color: #0d6efd !important;\n}\n\n.input-placeholder {\n  color: $input-placeholder-color; // Use the placeholder color variable\n}\n\n.modal-body .multiValue {\n  border-radius: 50px !important;\n}\n\n.button-style {\n  box-sizing: border-box;\n  border-radius: 5px;\n  background: #4403bf;\n  justify-content: flex-start;\n  align-items: center;\n  display: center;\n  color: white;\n  font-size: 16px;\n  line-height: 27px;\n  letter-spacing: 0.04px;\n  word-wrap: break-word;\n  border: none; // Remove border if not needed\n  cursor: pointer; // Add pointer cursor for interaction\n  text-align: center;\n}\n\n// Login\n\n/* styles/Login.css */\n.login-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n.login-heading {\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.left-side {\n  min-height: 100vh;\n  flex: 3;\n  background: #ffeee8;\n  position: sticky;\n  top: 0;\n}\n\n.mobile-create-btns {\n  width: 70%;\n}\n\nmobile-create-btns {\n  width: 70%;\n}\n\n.mobile-forgot {\n  display: none;\n}\n\n.forgot-icon {\n  display: none;\n}\n\n.otp-icon-div {\n  // display: none;\n  margin-bottom: 20px;\n}\n\n.right-side {\n  flex: 3;\n  padding: 40px 144px 40px 100px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  position: relative;\n}\n\nlabel {\n  font-size: 13px;\n  display: block;\n  color: $dark-3;\n}\n\n/* Add your styles for Input, Button, and other elements here */\n.forgot-password-link {\n  margin-top: 10px;\n  text-decoration: none;\n  cursor: pointer;\n  color: $primary-color;\n}\n\n.otp-phone {\n  color: $info-color;\n}\n\n.google-button {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  background: $secondary-color;\n  justify-content: flex-start;\n  align-items: center;\n  display: center;\n  color: $dark-1;\n  font-size: 16px;\n  line-height: 27px;\n  letter-spacing: 0.04px;\n  word-wrap: break-word;\n  border: 1px solid white; // Remove border if not needed\n  box-shadow: 2px 2px 4px rgb(94 92 92 / 64%);\n  cursor: pointer; // Add pointer cursor for interaction\n  text-align: center;\n}\n\n.google-icon {\n  margin-right: 10px;\n}\n\n.signup-link {\n  margin: 0;\n  cursor: pointer;\n  text-decoration: none;\n  color: $primary-color;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  content: url(\"../../public/chevron-right.svg\") !important;\n  margin-top: 3px;\n}\n\n.breadcrumb-item a {\n  text-decoration: none !important;\n  color: $primary-color;\n}\n\n.categoriesAccordion .accordion-item:first-of-type .accordion-button {\n  background-color: white;\n}\n\n.profile_main_div .dropdown-menu .show {\n  left: -146px !important;\n  top: 40px;\n}\n\n.filter-students .dropdown-menu .show {\n  left: 0px !important;\n}\n\n.delete-edit-icon {\n  height: 40px;\n  padding: 9.99px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10.99px;\n  display: inline-flex;\n  background-color: white;\n}\n\n.delete-edit-stu-icon {\n  height: 40px;\n  padding: 9.99px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10.99px;\n  display: inline-flex;\n}\n\n.delete-edit-stu-icon img {\n  width: 20px !important;\n}\n\n.delete-edit-icon img {\n  width: 20px !important;\n}\n\n.save-btn {\n  width: auto;\n}\n\n.deleteBtnModal {\n  border-radius: 28px;\n  border: 8px solid rgba(217, 247, 42, 0.2);\n  background: rgba(217, 247, 42, 0.3);\n  color: $darker-color;\n}\n\n.mblCards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.card-header {\n  background-color: #ffffff !important;\n}\n\n.mblCards-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\ntable {\n  border: 1.391px solid var(--Grey_2, #e4e4e4);\n  border-radius: 5px;\n}\n\ntr {\n  height: 55px !important;\n  text-align: start !important;\n}\n\ntd {\n  position: relative;\n  height: 55px !important;\n  padding: 12px 24px !important;\n  text-align: start !important;\n  width: inherit !important;\n}\n\ntd > div:first-child {\n  height: 100% !important;\n  display: flex;\n  align-items: center;\n  width: 100% !important;\n}\n\nth {\n  position: relative;\n  padding: 12px 24px !important;\n}\n\n.table-checkbox {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n}\n\n.table-checkbox:checked {\n  background-color: $darker-color !important;\n}\n\n// table input:checked {\n//   background-color: $darker-color !important;\n// }\n\n.mbl-card-checkbox {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.card-heading {\n  font-size: 14px;\n  color: var(--Grey_4, #1b2128);\n  text-decoration: none;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.Accordion-card {\n  height: 60px !important;\n  border-radius: 6px 6px 0px 0px !important;\n}\n\n.Accordion-card .card-header {\n  height: 100% !important;\n}\n\n.sm-table {\n  display: none;\n}\n\n.tox-promotion-link {\n  display: none !important;\n}\n\n.options-addQuestion p {\n  margin: 0 !important;\n}\n\n.formattedText p {\n  margin: 0 !important;\n}\n\n.tox-statusbar {\n  display: none !important;\n}\n\n.equation_image {\n  position: relative;\n  max-width: 75% !important;\n}\n\n.equation_tooltip {\n  display: none;\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #000;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.equation_image:hover + .equation_tooltip {\n  display: block;\n}\n\n.mq-math-mode .mq-sqrt-prefix {\n  left: 0.3em !important;\n  top: 0.2em !important;\n}\n\n.mq-math-mode sup.mq-nthroot {\n  padding-top: 0.3em !important;\n}\n\n.accordion-button {\n  height: 100%;\n  background-color: transparent !important;\n}\n\n.custom-select__multi-value__remove {\n  background-image: url(\"../../public/cross.png\") !important;\n  /* Set appropriate width and height for your custom image */\n  width: 20px;\n  height: 20px;\n  /* Ensure the image is displayed properly */\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  border: none !important;\n  /* Ensure cursor changes on hover */\n}\n\n#custom-switch {\n  width: 45px;\n  height: 25px;\n}\n\n.accordion-button {\n  padding: 8px 16px !important;\n}\n\n.formattedText {\n  // display: flex;\n  gap: 5px;\n  line-height: 30px;\n}\n\n.formattedText > span:first-child {\n  width: fit-content;\n  // height: 25px;\n}\n\n.inlineMath {\n  display: inline;\n}\n\n/* Add media queries for responsiveness */\n@media (max-width: 780px) {\n  .login-container .left-side {\n    display: none;\n  }\n\n  .login-container .right-side {\n    padding: 0px 20px 0px 20px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0px;\n  }\n\n  .forgot-icon {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 30px;\n  }\n\n  .mobile-forgot {\n    display: block !important;\n    text-align: center !important;\n    padding-bottom: 30px;\n  }\n\n  .otp-main-div {\n    width: 100% !important;\n  }\n\n  .otp-icon-div {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 30px;\n    margin-top: 40px;\n  }\n\n  .otp-heading {\n    font-size: 20px;\n  }\n\n  .otp-phone {\n    font-size: 20px;\n  }\n\n  .mobile-create-btns {\n    width: 90% !important;\n    position: fixed;\n    bottom: 90px;\n    z-index: 1000;\n  }\n\n  .mobile-create-btns-2nd {\n    width: 90% !important;\n    position: fixed;\n    bottom: 145px;\n    z-index: 1000;\n  }\n\n  .login-container {\n    flex-direction: column;\n  }\n\n  .right-side {\n    flex: 1;\n  }\n\n  .delete-edit-icon {\n    height: 100%;\n    padding: 8.99px;\n    border: none !important;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10.99;\n    display: inline-flex;\n  }\n\n  .delete-edit-icon img {\n    width: 20px !important;\n  }\n\n  .save-btn {\n    width: 100% !important;\n  }\n\n  .fix-width-button {\n    width: 100px !important;\n  }\n\n  .fix-width-action-button {\n    width: 140px !important;\n  }\n  .content-div {\n    height: 55vh;\n    overflow-y: auto;\n    @media (max-width: 768px) {\n      padding: 7px; // Adjust padding for smaller screens\n    }\n  }\n\n  .sidebar {\n    background-color: #ffffff;\n  }\n\n  .lg-table {\n    display: none !important;\n  }\n\n  .sm-table {\n    display: inline-table;\n  }\n\n  td > div:first-child {\n    height: 100% !important;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n    justify-content: flex-start !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 270px;\n    /* Adjust this value to your liking */\n  }\n}\n\n@media (max-width: 400px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 220px;\n    /* Adjust this value to your liking */\n  }\n}\n\n@media (max-width: 350px) {\n  .category-description {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 180px;\n    /* Adjust this value to your liking */\n  }\n}\n\n.subscription-info {\n  display: flex;\n  align-items: center;\n}\n.subscription-box {\n  background-color: blue !important; /* Adjust this color to match your design */\n  color: white;\n  padding: 11px 14px;\n  border-radius: 5px;\n  margin-right: 15px;\n  font-weight: bold;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n}\n.logout-dropdown .dropdown-toggle {\n  background: none !important;\n  border: none !important;\n  padding: 0;\n}\n\n.ql-editor {\n  white-space: normal !important;\n}\n\n.distractor-section {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f7f7f7;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.distractor-header {\n  font-size: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.distractor-header .required {\n  color: red;\n  margin-left: 0.25rem;\n}\n\n.distractor-description {\n  font-size: 0.875rem;\n  color: #555;\n  margin-bottom: 0.75rem;\n}\n\n.distractor-input-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.custom-input {\n  width: 200px;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.add-distractor-btn {\n  background-color: transparent;\n  border: 1px solid #4403bf;\n  color: #4403bf;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.add-distractor-btn:hover {\n  background-color: #4403bf;\n  color: #fff;\n}\n\n.distractor-list {\n  list-style: disc inside;\n  padding-left: 1rem;\n  margin: 0;\n}\n\n.distractor-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.25rem 0;\n}\n\n.remove-distractor-btn {\n  background: transparent;\n  border: none;\n  color: #4403bf;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: text-decoration 0.2s;\n}\n\n.remove-distractor-btn:hover {\n  text-decoration: underline;\n}\n\n// Fix tooltip alignment in tables\ntd .tooltip {\n  max-width: 300px !important;\n  z-index: 1070;\n}\n\ntd .tooltip-inner {\n  max-width: 300px !important;\n  text-align: left;\n  padding: 8px 12px;\n}\n","// Live Classes Styles\n@import \"../../../../../styles/theme.scss\";\n\n// Header Styles\n.live-class-header {\n  margin-bottom: 1.5rem;\n\n  .header-top {\n    padding: 1.5rem 1.5rem 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1rem;\n\n    @media (max-width: 768px) {\n      padding: 1rem 0.75rem;\n      gap: 0.75rem;\n    }\n\n    @media (max-width: 425px) {\n      padding: 0.75rem 0.5rem;\n      gap: 0.5rem;\n    }\n\n    .header-title {\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: var(--dark-1);\n      margin: 0;\n      white-space: nowrap;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n\n      @media (max-width: 425px) {\n        font-size: 1.1rem;\n      }\n    }\n\n    .action-container {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.75rem;\n      align-items: center;\n\n      @media (max-width: 768px) {\n        gap: 0.5rem;\n      }\n\n      @media (max-width: 425px) {\n        gap: 0.35rem;\n      }\n\n      .action-buttons {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.75rem;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          gap: 0.5rem;\n        }\n\n        @media (max-width: 425px) {\n          gap: 0.35rem;\n        }\n\n        button {\n          white-space: nowrap;\n          font-size: 0.9rem;\n          padding: 0.5rem 1rem;\n          border-radius: 6px;\n          transition: all 0.2s ease;\n\n          @media (max-width: 768px) {\n            font-size: 0.85rem;\n            padding: 0.4rem 0.75rem;\n          }\n\n          @media (max-width: 425px) {\n            font-size: 0.8rem;\n            padding: 0.35rem 0.6rem;\n          }\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n          }\n        }\n\n        // MultipleFilterDropdown styles\n        .multiple-filter-dropdown {\n          @media (max-width: 768px) {\n            .dropdown-toggle {\n              font-size: 0.85rem;\n              padding: 0.4rem 0.75rem;\n            }\n          }\n\n          @media (max-width: 425px) {\n            .dropdown-toggle {\n              font-size: 0.8rem;\n              padding: 0.35rem 0.6rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .filter-container {\n    padding: 0 1.5rem;\n\n    @media (max-width: 768px) {\n      padding: 0 0.75rem;\n    }\n\n    @media (max-width: 425px) {\n      padding: 0 0.5rem;\n    }\n  }\n}\n\n// Tab Styles\n.live-class-tabs-container {\n  padding: 0.5rem 1.5rem;\n  position: relative;\n\n  .live-class-tabs {\n    border-bottom: 1px solid var(--light-2);\n\n    .nav-item {\n      margin-bottom: -1px;\n      margin-right: 4px;\n    }\n\n    .nav-link {\n      border: 1px solid transparent;\n      border-bottom: none;\n      color: var(--dark-2);\n      font-size: 0.95rem;\n      font-weight: 500;\n      // padding: 0.65rem 1.25rem;\n      background-color: var(--light-3);\n      border-radius: 0;\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n      transition: all 0.2s ease;\n\n      &:hover:not(.active) {\n        background-color: var(--light-2);\n        color: var(--dark-1);\n      }\n\n      &.active {\n        color: var(--primary-color);\n        background-color: #fff;\n        border-color: var(--light-2);\n        border-bottom-color: #fff;\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          height: 3px;\n          // background-color: var(--primary-color);\n          border-top-left-radius: 4px;\n          border-top-right-radius: 4px;\n        }\n      }\n\n      .badge {\n        font-size: 0.7rem;\n        font-weight: 400;\n        padding: 0.25rem 0.5rem;\n        border-radius: 50px;\n      }\n    }\n  }\n\n  // Tab content\n  .tab-content {\n    margin-top: 1.5rem;\n    padding: 0 0.5rem;\n    overflow: visible !important;\n  }\n\n  .class-card-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 1rem;\n    overflow: visible !important;\n\n    .no-classes-message {\n      grid-column: 1 / -1;\n      text-align: center;\n      padding: 2rem;\n      color: var(--dark-3);\n    }\n  }\n\n  .load-more-container {\n    grid-column: 1 / -1;\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n    width: 100%;\n  }\n\n  .load-more-button {\n    padding: 0.5rem 2rem;\n    font-size: 0.9rem;\n    min-width: 150px;\n  }\n}\n\n// Card Styles\n.class-card {\n  border-radius: 8px;\n  border: 1px solid var(--light-2);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n  overflow: visible !important;\n  position: relative;\n\n  // &:hover {\n  //   // transform: translateY(-2px);\n  //   // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  //   z-index: 1 !important;\n  // }\n\n  // Different border colors based on class type\n  &.live-card {\n    border-left: 3px solid var(--error-color);\n  }\n\n  &.upcoming-card {\n    border-left: 3px solid var(--info-color);\n  }\n\n  &.completed-card {\n    border-left: 3px solid var(--dark-4);\n  }\n\n  &.suspended {\n    opacity: 0.7;\n    background-color: var(--light-3);\n  }\n\n  .card-body {\n    padding: 1rem;\n    overflow: visible !important;\n  }\n\n  // Class title and status badge\n  .class-title-container {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 0.75rem;\n\n    .class-title {\n      font-size: 1rem;\n      font-weight: 600;\n      margin-right: 0.75rem;\n      color: var(--dark-1);\n    }\n\n    .status-badge {\n      font-size: 0.7rem;\n      padding: 0.25rem 0.5rem;\n      border-radius: 4px;\n    }\n  }\n\n  // Class details\n  .class-details {\n    margin-bottom: 0.75rem;\n\n    .detail-item {\n      display: flex;\n      align-items: center;\n      margin-bottom: 0.5rem;\n      color: var(--dark-2);\n      font-size: 0.85rem;\n\n      .detail-icon {\n        margin-right: 0.5rem;\n        font-size: 0.85rem;\n        color: var(--dark-3);\n      }\n    }\n\n    .subject-tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.25rem;\n      margin-top: 0.5rem;\n\n      .subject-badge {\n        font-size: 0.7rem;\n        background-color: var(--light-3);\n        color: var(--dark-2);\n        padding: 0.25rem 0.5rem;\n      }\n    }\n  }\n\n  // Special status badges\n  .suspended-badge,\n  .rescheduled-badge {\n    margin-top: 0.5rem;\n\n    .badge {\n      font-size: 0.75rem;\n      padding: 0.25rem 0.5rem;\n    }\n  }\n\n  // Class Card Options (new component)\n  .class-card-right {\n    position: relative;\n  }\n\n  // Class Card Options styles\n  .class-card-options {\n    position: relative;\n\n    .options-toggle-btn {\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background-color: transparent;\n      border: none;\n      color: #6c757d;\n      transition: all 0.2s;\n\n      &:hover {\n        background-color: #f8f9fa;\n        color: #343a40;\n        z-index: 99999;\n      }\n    }\n\n    .options-menu {\n      position: absolute;\n      top: calc(100% + 5px);\n      right: 0;\n      min-width: 160px;\n      background-color: white;\n      border-radius: 8px;\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n      padding: 0.5rem 0;\n      z-index: 99999;\n      border: 1px solid rgba(0, 0, 0, 0.08);\n\n      .options-item {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        text-align: left;\n        background: none;\n        border: none;\n        padding: 0.6rem 1rem;\n        font-size: 0.875rem;\n        color: #343a40;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover {\n          background-color: #f8f9fa;\n          color: #0d6efd;\n        }\n\n        &:active,\n        &:focus {\n          outline: none;\n          background-color: #f0f7ff;\n        }\n\n        .option-icon {\n          margin-right: 10px;\n          width: 16px;\n          height: 16px;\n          color: #6c757d;\n        }\n      }\n    }\n  }\n\n  // Action buttons\n  .action-container {\n    display: flex;\n    justify-content: flex-start;\n\n    .action-buttons {\n      gap: 0.5rem;\n    }\n\n    .btn {\n      font-size: 0.85rem;\n      padding: 0.35rem 1rem;\n    }\n  }\n}\n\n// Enhanced Filters\n.enhanced-filters {\n  margin-bottom: 1.5rem;\n\n  .filter-toggle-btn {\n    display: flex;\n    align-items: center;\n    font-size: 0.95rem;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    background-color: #f8f9fa;\n    border-color: #e9ecef;\n    color: var(--dark-1);\n    border-radius: 6px;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #e9ecef;\n    }\n\n    svg {\n      font-size: 1rem;\n      color: var(--primary-color);\n    }\n\n    .badge {\n      font-size: 0.7rem;\n      font-weight: 500;\n      padding: 0.25rem 0.5rem;\n      background-color: var(--primary-color) !important;\n    }\n\n    .rotated {\n      transform: rotate(180deg);\n      transition: transform 0.2s ease;\n    }\n  }\n\n  .clear-filters-btn {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--primary-color);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n      color: var(--primary-color-dark);\n    }\n  }\n\n  .filter-panel {\n    margin-bottom: 1rem;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    // overflow: hidden;\n\n    .card-body {\n      padding: 1.25rem;\n      background-color: #ffffff;\n    }\n\n    // Search input styles\n    .input-group {\n      margin-bottom: 1.5rem;\n\n      .input-group-text {\n        background-color: white;\n        border-right: none;\n        color: var(--dark-2);\n\n        svg {\n          color: var(--primary-color);\n        }\n      }\n\n      .form-control {\n        border-left: none;\n        font-size: 0.95rem;\n\n        &:focus {\n          box-shadow: none;\n          border-color: #ced4da;\n        }\n      }\n\n      .btn-outline-secondary {\n        border-color: #ced4da;\n        color: var(--dark-2);\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n      }\n    }\n\n    .filter-category-title {\n      font-size: 1rem;\n      font-weight: 600;\n      margin-bottom: 0.75rem;\n      color: var(--dark-1);\n      position: relative;\n      padding-bottom: 0.5rem;\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 40px;\n        height: 2px;\n        background-color: var(--primary-color);\n      }\n    }\n\n    .filter-items-container {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.6rem;\n      margin-bottom: 1rem;\n    }\n\n    .filter-badge {\n      display: flex;\n      align-items: center;\n      font-size: 0.85rem;\n      font-weight: 500;\n      padding: 0.5rem 0.75rem;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: 1px solid transparent;\n\n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n\n      &[bg=\"light\"] {\n        background-color: #f1f3f5 !important;\n        color: var(--dark-1) !important;\n        border-color: #e9ecef;\n\n        &:hover {\n          background-color: #e9ecef !important;\n          border-color: #dee2e6;\n        }\n      }\n\n      &[bg=\"primary\"] {\n        background-color: var(--primary-color) !important;\n        color: white !important;\n\n        &:hover {\n          background-color: var(--primary-color-dark) !important;\n        }\n      }\n\n      .remove-filter {\n        margin-left: 0.5rem;\n        font-size: 0.7rem;\n        padding: 2px;\n        border-radius: 50%;\n        transition: all 0.2s;\n\n        &:hover {\n          background-color: rgba(255, 255, 255, 0.2);\n        }\n      }\n    }\n\n    // Filter action buttons\n    .btn {\n      padding: 0.5rem 1.25rem;\n      font-weight: 500;\n      font-size: 0.9rem;\n      border-radius: 6px;\n      transition: all 0.2s ease;\n\n      &:focus {\n        box-shadow: none;\n      }\n    }\n\n    .btn-outline-danger {\n      color: var(--error-color);\n      border-color: var(--error-color);\n\n      &:hover {\n        background-color: var(--error-color);\n        color: white;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);\n      }\n    }\n\n    .btn-outline-secondary {\n      color: var(--dark-2);\n      border-color: #ced4da;\n\n      &:hover {\n        background-color: var(--dark-2);\n        color: white;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 4px rgba(90, 106, 133, 0.2);\n      }\n    }\n\n    .btn-outline-primary {\n      color: var(--primary-color);\n      border-color: var(--primary-color);\n\n      &:hover {\n        background-color: var(--primary-color);\n        color: white;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 5px rgba(68, 3, 191, 0.25);\n      }\n    }\n  }\n\n  .active-filters {\n    margin-top: 1rem;\n\n    .text-muted {\n      font-size: 0.85rem;\n      font-weight: 500;\n    }\n\n    .active-filter-badge {\n      display: flex;\n      align-items: center;\n      font-size: 0.85rem;\n      font-weight: 500;\n      padding: 0.45rem 0.75rem;\n      border-radius: 6px;\n      background-color: #f1f3f5 !important;\n      color: var(--dark-1) !important;\n      border: 1px solid #e9ecef;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background-color: #e9ecef !important;\n        border-color: #dee2e6;\n        transform: translateY(-1px);\n      }\n\n      .remove-filter {\n        margin-left: 0.5rem;\n        font-size: 0.7rem;\n        cursor: pointer;\n        opacity: 0.7;\n        padding: 2px;\n        border-radius: 50%;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n  }\n}\n\n// Menu dropdown fixes\n.dropdown-menu {\n  z-index: 1050 !important;\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .live-class-header {\n    .header-top {\n      // flex-direction: column;\n      align-items: flex-start;\n\n      .header-title {\n        margin-bottom: 1rem;\n      }\n    }\n  }\n\n  .live-class-tabs-container {\n    padding: 0.5rem;\n\n    .live-class-tabs {\n      .nav-link {\n        padding: 0.5rem 0.75rem;\n        font-size: 0.85rem;\n      }\n    }\n\n    .class-card-container {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n/* Modern Live Class Component Styles */\n\n.modern-class-container {\n  padding: 1rem;\n\n  .live-classes-section {\n    .section-title {\n      font-weight: 600;\n      position: relative;\n    }\n\n    .pulse-animation {\n      animation: pulse 1.5s infinite;\n    }\n\n    .live-class-card {\n      transition: transform 0.2s, box-shadow 0.2s;\n      border-radius: 12px;\n\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;\n      }\n\n      .live-indicator {\n        .badge {\n          font-size: 0.7rem;\n          letter-spacing: 0.5px;\n        }\n      }\n\n      .card-title {\n        font-weight: 600;\n        margin-bottom: 0.5rem;\n        white-space: nowrap;\n        // overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .subject-badge {\n        font-size: 0.65rem;\n        padding: 0.3rem 0.5rem;\n        border-radius: 4px;\n        background: #f8f9fa;\n        color: #6c757d;\n        margin-right: 0.25rem;\n        margin-bottom: 0.25rem;\n        display: inline-block;\n        transition: all 0.2s;\n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n        &:hover {\n          background: #e9ecef;\n        }\n      }\n\n      .options-menu {\n        .options-toggle-btn {\n          width: 32px;\n          height: 32px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 50%;\n          background-color: transparent;\n          border: none;\n          color: #6c757d;\n          transition: all 0.2s;\n\n          &:hover {\n            background-color: #f8f9fa;\n            color: #343a40;\n          }\n        }\n      }\n    }\n\n    .no-live-classes {\n      i {\n        color: #ddd;\n        font-size: 3rem;\n      }\n    }\n  }\n\n  .secondary-classes-section {\n    // Custom tabs styling\n    .custom-tabs-container {\n      display: flex;\n      gap: 1.5rem;\n      border-bottom: 1px solid #dee2e6;\n      padding-bottom: 0.5rem;\n\n      .custom-tab {\n        cursor: pointer;\n        position: relative;\n        padding: 0.75rem 0.25rem;\n        font-weight: 600;\n        color: #6c757d;\n        transition: all 0.3s ease;\n\n        &:after {\n          content: \"\";\n          position: absolute;\n          bottom: -0.5rem;\n          left: 0;\n          width: 0;\n          height: 3px;\n          background: transparent;\n          transition: all 0.3s ease;\n        }\n\n        &.active {\n          color: #0d6efd;\n\n          &:after {\n            width: 100%;\n            background: #0d6efd;\n          }\n        }\n\n        &:hover:not(.active) {\n          color: #495057;\n\n          &:after {\n            width: 100%;\n            background: #dee2e6;\n          }\n        }\n\n        .tab-label {\n          margin-right: 0.25rem;\n        }\n\n        .badge {\n          vertical-align: middle;\n        }\n      }\n    }\n\n    // Enhanced class list item styling\n    .class-list-item {\n      transition: all 0.2s;\n      border-radius: 12px;\n      overflow: visible;\n      margin-bottom: 1rem;\n\n      &:hover {\n        // transform: translateY(-2px); // comment out due to the option menu issues\n        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;\n      }\n\n      &.suspended {\n        opacity: 0.8;\n        background-color: #f8f9fa;\n        border-left: 5px solid #dc3545 !important;\n        position: relative;\n\n        &:after {\n          content: \"SUSPENDED\";\n          position: absolute;\n          top: 0;\n          right: 0;\n          background-color: #dc3545;\n          color: white;\n          font-size: 0.7rem;\n          padding: 2px 8px;\n          font-weight: bold;\n          letter-spacing: 0.5px;\n          border-bottom-left-radius: 8px;\n        }\n\n        .class-title {\n          text-decoration: line-through;\n          opacity: 0.7;\n        }\n      }\n\n      .class-title {\n        font-weight: 600;\n        color: #343a40;\n        // overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .status-badge {\n        font-size: 0.65rem;\n        padding: 0.25rem 0.5rem;\n        letter-spacing: 0.5px;\n      }\n\n      .detail-group {\n        .detail-item {\n          display: flex;\n          align-items: center;\n          font-size: 0.9rem;\n          color: #495057;\n          margin-bottom: 0.5rem;\n\n          .detail-icon {\n            width: 18px;\n            height: 18px;\n            color: #0d6efd;\n            opacity: 0.8;\n          }\n        }\n      }\n\n      .subject-tags {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n\n        .subject-badge {\n          font-size: 0.65rem;\n          padding: 0.3rem 0.5rem;\n          border-radius: 4px;\n          background: #f8f9fa;\n          color: #6c757d;\n          margin-right: 0.25rem;\n          margin-bottom: 0.25rem;\n          display: inline-block;\n          transition: all 0.2s;\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n          &:hover {\n            background: #e9ecef;\n          }\n        }\n      }\n\n      .action-buttons {\n        .btn {\n          margin-bottom: 0.25rem;\n          border-radius: 6px;\n          padding: 0.375rem 0.75rem;\n          font-weight: 500;\n          font-size: 0.85rem;\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n          transition: all 0.2s;\n\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n          }\n        }\n      }\n\n      .suspended-badge,\n      .rescheduled-badge {\n        .badge {\n          padding: 0.4rem 0.7rem;\n          font-size: 0.75rem;\n          font-weight: 500;\n        }\n      }\n\n      .options-menu {\n        .options-toggle-btn {\n          width: 32px;\n          height: 32px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 50%;\n          background-color: transparent;\n          border: none;\n          color: #6c757d;\n          transition: all 0.2s;\n\n          &:hover {\n            background-color: #f8f9fa;\n            color: #343a40;\n          }\n        }\n      }\n    }\n\n    .list-body {\n      margin: -0.75rem;\n\n      @media (min-width: 1440px) {\n        margin: -0.6rem;\n      }\n\n      .class-list-item {\n        margin: 0.75rem;\n\n        @media (min-width: 1440px) {\n          margin: 0.6rem;\n        }\n      }\n    }\n  }\n}\n\n/* Animation keyframes */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .modern-class-container {\n    padding: 0.5rem;\n\n    .live-classes-section {\n      .section-title {\n        font-size: 1.25rem;\n        margin-bottom: 1rem;\n      }\n\n      .live-class-card {\n        margin-bottom: 0.75rem;\n\n        .card-body {\n          padding: 0.75rem;\n        }\n\n        .card-title {\n          font-size: 0.95rem;\n          margin-bottom: 0.25rem;\n        }\n\n        .card-subtitle {\n          font-size: 0.8rem;\n          margin-bottom: 0.5rem;\n        }\n\n        .class-time-info {\n          font-size: 0.8rem;\n          margin-bottom: 0.5rem;\n\n          .detail-icon {\n            width: 14px;\n            height: 14px;\n          }\n        }\n\n        .subject-badge {\n          font-size: 0.6rem;\n          padding: 0.2rem 0.4rem;\n          margin-right: 0.2rem;\n          margin-bottom: 0.2rem;\n        }\n\n        .btn {\n          font-size: 0.8rem;\n          padding: 0.3rem 0.6rem;\n        }\n      }\n    }\n\n    .secondary-classes-section {\n      .custom-tabs-container {\n        gap: 0.75rem;\n        padding-bottom: 0.25rem;\n\n        .custom-tab {\n          padding: 0.5rem 0.25rem;\n          font-size: 0.9rem;\n\n          .badge {\n            font-size: 0.65rem;\n            padding: 0.2rem 0.4rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Small Mobile Optimizations (425px to 300px) */\n@media (max-width: 425px) {\n  .modern-class-container {\n    padding: 0.25rem;\n\n    .live-classes-section {\n      .section-title {\n        font-size: 1.1rem;\n        margin-bottom: 0.75rem;\n      }\n\n      .live-class-card {\n        .card-body {\n          padding: 0.6rem;\n        }\n\n        .card-title {\n          font-size: 0.9rem;\n        }\n\n        .card-subtitle {\n          font-size: 0.75rem;\n        }\n\n        .class-time-info {\n          font-size: 0.75rem;\n\n          .detail-icon {\n            width: 12px;\n            height: 12px;\n          }\n        }\n\n        .subject-badge {\n          font-size: 0.55rem;\n          padding: 0.15rem 0.3rem;\n        }\n\n        .btn {\n          font-size: 0.75rem;\n          padding: 0.25rem 0.5rem;\n        }\n      }\n    }\n\n    .secondary-classes-section {\n      .custom-tabs-container {\n        gap: 0.5rem;\n\n        .custom-tab {\n          padding: 0.4rem 0.2rem;\n          font-size: 0.85rem;\n          display: flex;\n          align-items: center;\n          flex-wrap: nowrap;\n          white-space: nowrap;\n\n          .tab-label {\n            font-size: 0.75rem;\n          }\n\n          .badge {\n            font-size: 0.6rem;\n            padding: 0.15rem 0.3rem;\n            margin-left: 0.25rem;\n          }\n        }\n      }\n    }\n  }\n\n  .class-list-item-mobile {\n    .card-body {\n      padding: 0.75rem !important;\n\n      @media (min-width: 1440px) {\n        padding: 0.6rem !important;\n      }\n    }\n\n    .class-title {\n      font-size: 0.9rem;\n\n      @media (min-width: 1440px) {\n        font-size: 0.8rem;\n      }\n    }\n\n    .status-badge {\n      font-size: 0.6rem;\n      padding: 0.2rem 0.4rem;\n\n      @media (min-width: 1440px) {\n        font-size: 0.7rem;\n        padding: 0.15rem 0.3rem;\n      }\n    }\n\n    .class-details-mobile {\n      .detail-row {\n        font-size: 0.75rem;\n\n        @media (min-width: 1440px) {\n          font-size: 0.7rem;\n        }\n\n        .detail-icon {\n          width: 14px;\n          height: 14px;\n\n          @media (min-width: 1440px) {\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n    }\n\n    .subject-tags-mobile {\n      .subject-badge {\n        font-size: 0.65rem;\n        padding: 0.3rem 0.5rem;\n\n        @media (min-width: 1440px) {\n          font-size: 0.7rem;\n          padding: 0.25rem 0.4rem;\n        }\n      }\n    }\n\n    .action-buttons-mobile {\n      .btn {\n        font-size: 0.85rem;\n        padding: 0.375rem 0.75rem;\n\n        @media (min-width: 1440px) {\n          font-size: 0.7rem;\n          padding: 0.3rem 0.6rem;\n        }\n      }\n    }\n  }\n}\n\n/* Extra Small Mobile Optimizations (below 390px) */\n@media (max-width: 390px) {\n  .modern-class-container {\n    .secondary-classes-section {\n      .custom-tabs-container {\n        gap: 0.25rem;\n\n        .custom-tab {\n          padding: 0.3rem 0.15rem;\n          font-size: 0.7rem;\n\n          .tab-label {\n            font-size: 0.65rem;\n          }\n\n          .badge {\n            font-size: 0.55rem;\n            padding: 0.1rem 0.25rem;\n            margin-left: 0.2rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Live Classes Slider Optimizations */\n.live-classes-slider {\n  @media (max-width: 425px) {\n    padding: 0 30px; // Reduced padding for arrows\n\n    .slider-arrow {\n      width: 30px;\n      height: 30px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    .slider-container {\n      .row {\n        .col {\n          padding: 0 8px;\n        }\n      }\n    }\n  }\n}\n\n/* Additional Mobile Optimizations */\n@media (max-width: 300px) {\n  .modern-class-container {\n    .live-classes-section {\n      .section-title {\n        font-size: 1rem;\n      }\n\n      .live-class-card {\n        .card-body {\n          padding: 0.5rem;\n        }\n\n        .card-title {\n          font-size: 0.85rem;\n        }\n\n        .card-subtitle {\n          font-size: 0.7rem;\n        }\n\n        .class-time-info {\n          font-size: 0.7rem;\n        }\n\n        .subject-badge {\n          font-size: 0.5rem;\n          padding: 0.1rem 0.25rem;\n        }\n\n        .btn {\n          font-size: 0.7rem;\n          padding: 0.2rem 0.4rem;\n        }\n      }\n    }\n\n    .class-list-item-mobile {\n      .card-body {\n        padding: 0.5rem !important;\n      }\n\n      .class-title {\n        font-size: 0.85rem;\n      }\n\n      .status-badge {\n        font-size: 0.55rem;\n        padding: 0.15rem 0.3rem;\n      }\n\n      .class-details-mobile {\n        .detail-row {\n          font-size: 0.7rem;\n        }\n      }\n\n      .subject-tags-mobile {\n        .subject-badge {\n          font-size: 0.5rem;\n          padding: 0.1rem 0.25rem;\n        }\n      }\n\n      .action-buttons-mobile {\n        .btn {\n          font-size: 0.7rem;\n          padding: 0.2rem 0.4rem;\n        }\n      }\n    }\n  }\n}\n\n.live-classes-slider {\n  position: relative;\n  // overflow: hidden;\n  padding: 0 40px; // Space for arrows\n\n  @media (min-width: 992px) {\n    padding: 0;\n    overflow: visible;\n  }\n\n  .slider-container {\n    // overflow: hidden;\n    width: 100%;\n\n    @media (min-width: 992px) {\n      overflow: visible;\n    }\n\n    .row {\n      margin: 0;\n      transition: transform 0.3s ease-in-out;\n      display: flex;\n      flex-wrap: nowrap;\n\n      @media (min-width: 992px) {\n        flex-wrap: wrap;\n        transition: none;\n      }\n    }\n\n    .col {\n      padding: 0 12px;\n      flex: 0 0 auto;\n\n      @media (min-width: 992px) {\n        flex: 0 0 auto;\n      }\n    }\n  }\n\n  .slider-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 2;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e0e0e0;\n    padding: 0;\n\n    @media (min-width: 992px) {\n      display: none;\n    }\n\n    &:hover {\n      background: #f8f9fa;\n    }\n\n    &.slider-arrow-left {\n      left: 0;\n    }\n\n    &.slider-arrow-right {\n      right: 0;\n    }\n  }\n}\n\n/* Mobile-optimized list view styles */\n.class-list-item-mobile {\n  border-radius: 12px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;\n  }\n\n  &.suspended {\n    opacity: 0.8;\n    background-color: #f8f9fa;\n    border-left: 5px solid #dc3545 !important;\n    position: relative;\n\n    &:after {\n      content: \"SUSPENDED\";\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: #dc3545;\n      color: white;\n      font-size: 0.7rem;\n      padding: 2px 8px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      border-bottom-left-radius: 8px;\n    }\n\n    .class-title {\n      text-decoration: line-through;\n      opacity: 0.7;\n    }\n  }\n\n  .card-body {\n    padding: 0.75rem !important;\n\n    @media (min-width: 1440px) {\n      padding: 0.6rem !important;\n    }\n  }\n\n  .title-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n    min-width: 0;\n\n    .status-badge {\n      flex-shrink: 0;\n    }\n\n    .title-wrapper {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n\n      .class-title {\n        margin: 0;\n        white-space: nowrap;\n        // overflow: hidden;\n        text-overflow: ellipsis;\n        flex: 1;\n        min-width: 0;\n      }\n\n      .options-menu {\n        flex-shrink: 0;\n        margin-left: auto;\n      }\n    }\n  }\n\n  .class-title {\n    font-size: 0.9rem;\n\n    @media (min-width: 1440px) {\n      font-size: 0.8rem;\n    }\n  }\n\n  .status-badge {\n    font-size: 0.6rem;\n    padding: 0.2rem 0.4rem;\n\n    @media (min-width: 1440px) {\n      font-size: 0.7rem;\n      padding: 0.15rem 0.3rem;\n    }\n  }\n\n  .class-details-mobile {\n    .detail-row {\n      display: flex;\n      align-items: center;\n      margin-bottom: 0.5rem;\n      color: #495057;\n\n      .detail-icon {\n        width: 16px;\n        height: 16px;\n        color: #0d6efd;\n        opacity: 0.8;\n        flex-shrink: 0;\n      }\n\n      span {\n        color: #6c757d;\n      }\n    }\n  }\n\n  .subject-tags-mobile {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n\n    .subject-badge {\n      font-size: 0.65rem;\n      padding: 0.3rem 0.5rem;\n      border-radius: 4px;\n      background: #f8f9fa;\n      color: #6c757d;\n      display: inline-block;\n      transition: all 0.2s;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        background: #e9ecef;\n      }\n    }\n  }\n\n  .action-buttons-mobile {\n    .btn {\n      border-radius: 6px;\n      padding: 0.375rem 0.75rem;\n      font-weight: 500;\n      font-size: 0.85rem;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n      transition: all 0.2s;\n\n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n      }\n    }\n  }\n\n  .rescheduled-badge {\n    .badge {\n      font-size: 0.75rem;\n      padding: 0.4rem 0.7rem;\n      font-weight: 500;\n    }\n  }\n\n  .options-menu {\n    .options-toggle-btn {\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background-color: transparent;\n      border: none;\n      color: #6c757d;\n      transition: all 0.2s;\n\n      &:hover {\n        background-color: #f8f9fa;\n        color: #343a40;\n      }\n    }\n  }\n}\n\n// Live Classes Grid Layout\n.live-classes-grid {\n  .row {\n    margin: -0.75rem;\n\n    @media (min-width: 1440px) {\n      margin: -0.6rem;\n    }\n  }\n\n  .col {\n    padding: 0.75rem;\n\n    @media (min-width: 1440px) {\n      padding: 0.6rem;\n    }\n  }\n}\n\n.live-class-card {\n  transition: transform 0.2s ease-in-out;\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n\n  .card-body {\n    padding: 1.25rem;\n\n    @media (min-width: 1440px) {\n      padding: 1rem;\n    }\n  }\n\n  .card-title {\n    font-size: 1.1rem;\n    margin-bottom: 0.5rem;\n\n    @media (min-width: 1440px) {\n      font-size: 0.8rem;\n    }\n  }\n\n  .card-subtitle {\n    font-size: 0.9rem;\n\n    @media (min-width: 1440px) {\n      font-size: 0.7rem;\n    }\n  }\n\n  .subject-tags {\n    .badge {\n      font-size: 0.8rem;\n      padding: 0.35em 0.65em;\n\n      @media (min-width: 1440px) {\n        font-size: 0.7rem;\n        padding: 0.4em 0.7em;\n      }\n    }\n  }\n\n  .btn {\n    font-size: 0.9rem;\n    padding: 0.5rem 1rem;\n\n    @media (min-width: 1440px) {\n      font-size: 0.7rem;\n      padding: 0.6rem 1.2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
